import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';

import moment from 'moment';
import 'moment-timezone';
import _ from 'lodash';

import AddToCart from '../AddToCart';
import AddToList from '../AddToList';
import PartsNetItemSearchBox from './partsNetItemSearchBox';

import { routes } from '../../../../redux/api/routes';
const { searchAndPayInvoicesURLEmp, searchAndPayInvoicesURLCust, adBuilderActionURL, getItemsCount, resources } = routes;

/* Dialogs */
import GenericOverlayDialog from '../../../dialogs/genericOverlayDialog';
import CreatePriceTagRedirectDialog from '../../../dialogs/createPriceTagRedirectDialog';
import SelectAccountAndPriceSourceOverlayDialog from '../../../dialogs/selectAccountAndPriceSourceOverlayDialog';
import NoHelpResultsFoundOverlayDialog from '../../../dialogs/noHelpResultsFoundOverlayDialog';
import SessionStatusOverlayDialog from '../../../dialogs/sessionStatusOverlayDialog';

/* Actions */
import {
	setSelectedADC,
	saveViewRequestsListBackup,
	saveMobileView,
	saveClaimFormsDocuments,
	resetBrochurePayload,
	saveFullCatalogDocuments,
	selectBrochureCreateOption,
	/*new brochure single change*/
	selectFeatureCreateOption,
	saveManageOrdersListBackup,
	savePimDataForList,
	// getUsersOfAccount,
	saveBackOrders,
	saveBulkOrdersHold,
	saveProductLine,
	getPackageList,
	savePackageList,
	getSavedBrochures,
	getSavedExports,
	getPerformanceData,
	getMonogramData,
	getPrestigeData,
	getGeDistributorData,
	getDocuments,
	getUserProfile,
	updateSelectedAddress,
	getGEAdBuilderKey,
	getEncryptedACB,
	saveUserProfile,
	getLocalUserDetails,
	getSalesAgreementHandBook,
	savePostLoginSearchKeyword,
	resetSearchKeywordSuggestionList,
	saveSearchKeywordSuggestionList,
	getSearchKeywordSuggestionList,
	updateFromWhereProductLineClicked,
	updateAvailabilityWithPricesAndDiscounts,
	saveProductLineNarrowYourResultsFilters,
	getProductLineNarrorYourResultFilters,
	checkPricesForSearchResult,
	getProductLineFilters,
	checkServicesPricesForCartPage,
	updateCartOrderPoints,
	resetProductNumberKeywordResultList,
	resetProductAvailabilityResultList,
	resetProductPricesResultList,
	saveMonogramData,
	savePerformanceData,
	savePrestigeData,
	saveGeDistributorData,
	clearDeliveryMethodFromBackup,
	getFileURL,
	saveSelectedAddressBackup
} from '../../../../redux/actions';
import NewShipToAddressOverlayDialog from '../../../dialogs/newShipToAddressOverlayDialog';
import { FREIGHT_DOCUMENT_SUBCLASSES, MULTI_PACK_DOCUMENT_SUBCLASSES, PNET_APP_QUERY_PARAM } from '../../../common/partsNetConstants';
import { NCRP_ENABLED_SALES_AGREEMENT_TYPES } from '../../../common/ncrpConstants';
import AddressSearchDialog from '../../../dialogs/addressSearchDialog';

const DISABLED_ADC_PATHS_FOR_MAN_REPS = ['/quickorder', '/cart', '/order/createOrder', '/createorder/orderreview']

class Header extends Component {

    constructor(props) {
        super(props);
        this.state = {
			activeMenuIndex: null,

			product: '',
			showSideBar:false,
            // diolog variables
            genericDialogHeading: '',
            genericDialogText: '',
            modalButtons: '',

			showGenericOverlayDialog: false,
			showPackageNotFoundOverlayDialog: false,
			showSavedBrochuresNotFoundOverlayDialog: false,
			showNoHelpResultsFoundOverlayDialog: false,

			showCreatePriceTagDialog: false,

			showSelectAccountAndPriceSourceOverlayDialog: false,

			showSearchLoading: false,
			showSuggestion: false,
			suggestionAvailabilityCallCompleted: false,
			suggestionPricingCallCompleted: false,
			searchKeywordSuggestionResult: null,
			suggestionAvailabilityResult: null,
			suggestionPricingResult: null,
			isCartProductPriceCallCompleted: false,
			isCartServicePriceCallCompleted: false,
			isCartPimDataCallCompleted: false,
			isCartGetOrgAttributesCompleted: false,
			showSubcategories: false,
			showSearchMobileSection:false,
			mobileView:true,
			isFreightDocumentAvailable: props.state.user && props.state.user.selectedPriceSource && FREIGHT_DOCUMENT_SUBCLASSES.includes(props.state.user.selectedPriceSource['Sub Account Classification']),
			isMultiPackFileAvailable: props.state.user && props.state.user.selectedPriceSource && MULTI_PACK_DOCUMENT_SUBCLASSES.includes(props.state.user.selectedPriceSource['Sub Account Classification'])
        }
		this.setWrapperRef = this.setWrapperRef.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
		this.handleGetHelpDocuments = this.handleGetHelpDocuments.bind(this);
		this.handleGetHelpDocumentsURL = this.handleGetHelpDocumentsURL.bind(this);
		this.handlePriceBulletins = this.handlePriceBulletins.bind(this);
		this.handleDialog = this.handleDialog.bind(this);
		this.handleMyProfileClick = this.handleMyProfileClick.bind(this);
		this.saveSearchKeywordResultToStore = this.saveSearchKeywordResultToStore.bind(this);
		this.callBackForRedirectToCartPage = this.callBackForRedirectToCartPage.bind(this);
		this.getShippingAddressZipCode = this.getShippingAddressZipCode.bind(this);
		this.getShippingAddressState = this.getShippingAddressState.bind(this);
		this.callBackAfterAll = this.callBackAfterAll.bind(this);
		this.getDemadClassforAgreement = this.getDemadClassforAgreement.bind(this);
		this.partsNetSearchBoxRef = null;
    }

	getShippingAddressZipCode() {
		const self = this;
		// const { createOrderPayloadBackup } = self.props.state.order;
		// if(createOrderPayloadBackup && createOrderPayloadBackup.createOrderForm && createOrderPayloadBackup.createOrderForm.params && createOrderPayloadBackup.createOrderForm.params.shippingAddress && createOrderPayloadBackup.createOrderForm.params.shippingAddress.zip) {
		// 	return createOrderPayloadBackup.createOrderForm.params.shippingAddress.zip.split("-")[0];
		// }
		return self.props.customZipCode;
	}

	getShippingAddressState() {
		const self = this;
		const { createOrderPayloadBackup } = self.props.state.order;
		if(createOrderPayloadBackup && createOrderPayloadBackup.createOrderForm && createOrderPayloadBackup.createOrderForm.params && createOrderPayloadBackup.createOrderForm.params.shippingAddress && createOrderPayloadBackup.createOrderForm.params.shippingAddress.state) {
			return createOrderPayloadBackup.createOrderForm.params.shippingAddress.state;
		}
		return null;
	}

	setHoverMenu(activeMenuIndex) {
		this.setState({
			activeMenuIndex
		})
	}

	handleMainCategoryHover = () => {
		this.setState({ showSubcategories: true });
	};
	
	handleMainCategoryLeave = () => {
		this.setState({ showSubcategories: false});
	};

	redirectProductLineSearch(navigationState, label, event) {
		event.preventDefault();
		if (window.location.pathname === encodeURI("/search-result/product-line/"+label+"|"+navigationState.replace("?","")).toString()) {
			this.setHoverMenu(null);
			return;
		} else {
			const self = this,
				{ selectedAccount, selectedPriceSource } = this.props.state.user;
			//setiing the label in state to use in noRecordsFoundOverlayDialog
			this.setState({
				product: label
			});

			self.props.saveProductLine({
				navigationState: navigationState,
				label: label
			});

			this.props.updateFromWhereProductLineClicked('header');
			// reset keyword result list, availability list, and prices list
			self.props.resetProductNumberKeywordResultList();
			self.props.resetProductAvailabilityResultList();
			self.props.resetProductPricesResultList();

			self.props.checkAndSetSearchResult(
				'product-line',
				selectedAccount.ACCOUNTNUMBER,
				selectedPriceSource.AGREEMENT_NUMBER,
				self.props.customZipCode,
				"",
				navigationState,
				response => {
					// Check if both (prices and availability) service call are completed or not
					if(self.props.state.product.numberOfParallelCallForProductPrices === self.props.state.product.numberCompletedOfParallelCallForProductPrices && self.props.state.product.isProductAvailabilityCallCompleted) {
						// add prices to availability existing object and update it in to store before redirecting to search result page
						self.props.updateAvailabilityWithPricesAndDiscounts();

						//get filters if product line is the type of search,
						//filter will be get once after getting actual available products only
						//Prepare list of sku list of available products
						var skuList = [];
						self.props.state.product.productResultAvailability.map((item, index) => {
							skuList.push({
								"sku": item.sku
							});
							return null;
						});
						skuList.length > 0 && self.props.getProductLineFilters(skuList, navigationState.replace("?", ""));
						self.props.fireGTMTag('Header Product Line', {
							navElementText: label,
							navURL: '/search-result/product-line/' + encodeURI(label+"|"+navigationState.replace("?",""))
						});
						browserHistory.push('/search-result/product-line/' + encodeURI(label+"|"+navigationState.replace("?","")));
					}
				}
			);

			//Make parallel call for narrow your result filters
			self.props.saveProductLineNarrowYourResultsFilters(null);
			//get categoryId
			const categoryId = navigationState.replace('?N=','');
			self.props.getProductLineNarrorYourResultFilters("requestType=getProductLine&categoryId="+categoryId);
		}
		this.showSideBarMenuClose(event);
	}

	handlePrestigePIFTrackerClick(event){
		event.preventDefault();
		var self = this;
		self.setHoverMenu(null);
		const { prestigeData } = self.props.state.resources;
		//If already store contains data then no service call should be made
		let dataByAccountNumber = prestigeData && prestigeData.find(item => item.accountNumber === self.props.getSelectedAccountNumber());
		dataByAccountNumber = dataByAccountNumber && dataByAccountNumber.data;
		if(dataByAccountNumber) {
			self.props.fireGTMTag('Header Prestige PIF Tracker');
			browserHistory.push("/resources/prestigepif");
		}
		// if data is not available
		else if(!dataByAccountNumber) {
			self.props.getPrestigeData("requestType=pres&accountNumber="+self.props.getSelectedAccountNumber()+"&year=2025", response => {
				if(!response.status) {
					self.setState({
						errorMessage: response.responseMessage
					})
				} else {
					self.props.savePrestigeData({
						accountNumber: self.props.getSelectedAccountNumber(),
						data: response
					});
					self.props.fireGTMTag('Header Prestige PIF Tracker');
					browserHistory.push("/resources/prestigepif");
				}
			});
		}
		this.showSideBarMenuClose(event);
	}

	handleGeAppDistPifClick(event){
		event.preventDefault();
		var self = this;
		self.setHoverMenu(null);
		const { GeAppDistributionData } = self.props.state.resources;
		//If already store contains data then no service call should be made
		let dataByAccountNumber = GeAppDistributionData && GeAppDistributionData.find(item => item.accountNumber === self.props.getSelectedAccountNumber());
		dataByAccountNumber = dataByAccountNumber && dataByAccountNumber.data;
		if(dataByAccountNumber) {
			self.props.fireGTMTag('Header 100% GE Appliances Distributor PIF');
			browserHistory.push("/resources/gedistributor");
		}
		// if data is not available
		else if(!dataByAccountNumber) {
			self.props.getGeDistributorData("requestType=gedlr&accountNumber="+self.props.getSelectedAccountNumber()+"&year=2025", response => {
				if(!response.status) {
					self.setState({
						errorMessage: response.responseMessage
					})
				} else {
					self.props.saveGeDistributorData({
						accountNumber: self.props.getSelectedAccountNumber(),
						data: response
					});
					self.props.fireGTMTag('Header 100% GE Appliances Distributor PIF');
					browserHistory.push("/resources/gedistributor");
				}
			});
		}
		this.showSideBarMenuClose(event);
	}
	componentDidMount() {
		// let localStrogeObj = this.props.getLocalStorageVar(localStorageVar);
		// redirectCnetObj = this.props.getLocalStorageVar(redirectURLCNetVar);

		let page = window.location.pathname;
		if(page.indexOf('cart') > -1 || page.indexOf('list') > -1) {
			page = page.replace('/','');
		}

		// if found account number from local storage, then it was already selected
		const { user } = this.props.state;
        if(user.selectedAccount && user.selectedPriceSource) {
			this.setState({
				showSelectAccountAndPriceSourceOverlayDialog: false
			});
        } else {
			this.setState({
				showSelectAccountAndPriceSourceOverlayDialog: true
			});
		}
		document.addEventListener("mousedown", this.handleClickOutside);
	}

	componentWillUnmount() {
		document.removeEventListener("mousedown", this.handleClickOutside);
	  }

	  setWrapperRef(node) {
		this.wrapperRef = node;
	  }
	  handleClickOutside(event) {
		if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.showSideBar) {
			this.showSideBarMenuClose(event);
		}
	  }

	UNSAFE_componentWillReceiveProps(nextProps) {
		const nextSelectedPriceSource = nextProps.state.user.selectedPriceSource;
		const nextAddressList = nextProps.state.user.addressList;

		if (nextSelectedPriceSource  && nextAddressList &&
			(nextAddressList !== this.props.state.user.addressList || nextSelectedPriceSource !== this.props.state.user.selectedPriceSource || nextProps.isInternationalPartsCustomer !== this.props.isInternationalPartsCustomer)) {
			const soldToAddresses = this.props.getAddressesByCategory('SOLD_TO');
			let soldToAddress, limitNewShipToAddressTo;
			
			if (nextSelectedPriceSource.AGREEMENT_TYPE === 'GEA Parts') {
				if (soldToAddresses && soldToAddresses.length) {
					soldToAddress = soldToAddress = soldToAddresses[0];
					if (nextSelectedPriceSource['Sub Account Classification'] === 'PARTS-AWD' && soldToAddress && soldToAddress.COUNTRY === 'CA') {
						limitNewShipToAddressTo = 'CANADA';
					} else if (!nextProps.isInternationalPartsCustomer && soldToAddress && soldToAddress.COUNTRY === 'US') {
						limitNewShipToAddressTo = 'US DOMESTIC';
					} else if (nextProps.isInternationalPartsCustomer) {
						limitNewShipToAddressTo = 'INTERNATIONAL';
					}
				}
			}

			let isNCRPAllowed = false;
			if (nextSelectedPriceSource.AGREEMENT_TYPE && NCRP_ENABLED_SALES_AGREEMENT_TYPES.includes(nextSelectedPriceSource.AGREEMENT_TYPE.toUpperCase()) &&
				nextProps.state.user.userDetails.typeOfUser !== 'customer' && nextAddressList.responseObject && nextAddressList.responseObject.length &&
				!nextAddressList.responseObject.some(address => address.PURPOSE === 'SOLD_TO' && address.STATUS === 'A' && address.COUNTRY !== 'US')) {
				isNCRPAllowed = true;
			}

			this.setState({
				isNCRPAllowed,
				soldToAddress,
				limitNewShipToAddressTo
			})
		}

		if (nextSelectedPriceSource && (!this.props.state.user.selectedPriceSource || this.props.state.user.selectedPriceSource['Sub Account Classification'] !== nextSelectedPriceSource['Sub Account Classification'])) {
			this.setState({
				isFreightDocumentAvailable: FREIGHT_DOCUMENT_SUBCLASSES.includes(nextSelectedPriceSource['Sub Account Classification']),
				isMultiPackFileAvailable: MULTI_PACK_DOCUMENT_SUBCLASSES.includes(nextSelectedPriceSource['Sub Account Classification'])
			});
		}
	}

	handleCreatePriceTags(event) {
		event.preventDefault();
		var self = this;
		self.setHoverMenu(null);
		self.setState({
			showCreatePriceTagDialog: false
		}, () => {
			self.setState({
				showCreatePriceTagDialog: true
			});
		});
		this.showSideBarMenuClose(event);
	}

    // event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();

		if(dialog === 'SelectAccountAndPriceSourceOverlayDialog' && flag === false) {
			const self = this;
			// Reset search keyword and search result
			self.productNumberInput.value = '';
			//save all search string in store for showing next result page
			self.props.savePostLoginSearchKeyword('');
			//in case of space reset suggestion list
            self.props.resetSearchKeywordSuggestionList();
		}
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	handleGetHelpDocuments(param, whichPage, tagName, dialogHeading, event) {
		event && event.preventDefault();
		const self = this;
		self.setHoverMenu(null);
		// second param says whether it needs to be saved into store
		param += `&accountNumber=${self.props.getSelectedAccountNumber()}`;
		self.props.getDocuments(param, true, response => {
			response.responseObject = _.pullAllBy(response.responseObject, [{file: ""}], "file");
			if(!response.status || response.responseObject.length === 0) {
				self.setState({
					genericDialogHeading: dialogHeading,
					genericDialogText: 'No documents found.',
					modalButtons: 'ok'
				}, () => {
					self.handleDialog('GenericOverlayDialog', true);
				});
			} else if(whichPage !== '') {
				if(whichPage.indexOf('claimforms') !== -1) {
					self.props.saveClaimFormsDocuments(response);
				} else if(whichPage.indexOf('fullcatalog') !== -1) {
					self.props.saveFullCatalogDocuments(response);
				}
				self.props.fireGTMTag(tagName);
				browserHistory.push(whichPage);
			} else {
				window.open(response.responseObject[0].url);
			}
			/*else {
				browserHistory.push("/"+encodeURI(pathName)+"/help");
			}*/
		});
		this.showSideBarMenuClose(event);
	}

	handlePriceBulletins(param, whichPage, tagName, dialogHeading, event) {
		event && event.preventDefault();
		const self = this;
		self.setHoverMenu(null);
		// second param says whether it needs to be saved into store
		param += `&accountNumber=${self.props.getSelectedAccountNumber()}`;
		self.props.getDocuments(param, true, response => {
			if (response.responseObject) {
				response.responseObject =  JSON.parse(JSON.stringify(response.responseObject.filter(itm =>
					itm.fileExtension === 'pdf' &&
					itm.salesChannel === self.props.getSelectedAccountType() &&
					itm.customerClass.indexOf(self.props.customerClassCodeOfSelectedAccount) !== -1
				)));
			}
			if(!response.status || response.responseObject.length === 0) {
				self.setState({
					genericDialogHeading: dialogHeading,
					genericDialogText: 'No documents found.',
					modalButtons: 'ok'
				}, () => {
					self.handleDialog('GenericOverlayDialog', true);
				});
			} else {
				self.props.fireGTMTag(tagName);
				browserHistory.push(whichPage);
			}
		});
		this.showSideBarMenuClose(event);
	}

	handleGetHelpDocumentsURL(param, event) {
		event && event.preventDefault();
		var self = this;
		if(self.state.showSideBar){
			this.setState(prevState => ({
				showSideBar: !prevState.showSideBar
			  }));  
		}
		let pathName = location.pathname.trim().replace('/', '');
		self.setHoverMenu(null);
		self.setState({
			showNoHelpResultsFoundOverlayDialog: false
		});
		// check isOrderPlaced flag is set in store to verify if it is confirmation page or review page
		if(pathName.indexOf('/orderreview') !== -1 && self.props.state.order.isOrderPlaced) {
			pathName = pathName.replace('/orderreview', '/orderconfirmation');
		}
		param += `&pageName=${pathName}`;
		// second param says whether it needs to be saved into store
		param += `&accountNumber=${self.props.getSelectedAccountNumber()}`;
		self.props.getDocuments(param, true, response => {
			if(!response.status || !response.responseObject) {
				self.setState({
					showNoHelpResultsFoundOverlayDialog: true
				});
			} else {
				self.props.fireGTMTag('Header Help',{
					navURL: response.responseObject
				});
				window.open(response.responseObject);
			}
		});
	}

	handleCreatePackage(event) {
		const self = this;
		event.preventDefault();
		self.setHoverMenu(null);
		self.props.fireGTMTag('Header Create Package');
		browserHistory.push('/createpackage');
		this.showSideBarMenuClose(event);
	}

	handleCreateBrochureDialog(brochureCreateOption, event) {
		const self = this;
		self.props.handleCreateBrochure(brochureCreateOption, 'header', event);
		self.setHoverMenu(null);
		this.showSideBarMenuClose(event);
	}

	handleApproveReturns(event) {
		event.preventDefault();
		const self = this;
		self.props.fetchApproveReturnsList('/approvereturns');
		self.setHoverMenu(null);
		self.props.fireGTMTag('Header Approve Returns and Credits');
		self.showSideBarMenuClose(event);
	}

	handleRedirection(navURL, tagName, linkOpen, internalApp, event) {
		event.preventDefault();
		this.setHoverMenu(null);
		this.props.fireGTMTag(tagName,{
			navURL
		});
		if (internalApp) {
			browserHistory.push(navURL);
		} else {
			window.open(navURL, linkOpen);
		}
		this.showSideBarMenuClose(event);
	}
	handleCoopAdvertising(navURL, tagName, linkOpen, internalApp, event) {
		event.preventDefault();
		const self = this;
		const { state } = self.props;
		const { userDetails} = state.user;
		self.props.getEncryptedACB(`requestType=getACBEncryptedData&userType=${userDetails.typeOfUser}&userId=${userDetails.sso}&accountNumber=${self.props.getSelectedAccountNumber()}`, (response) => {
			if(response.responseObject){
				this.setHoverMenu(null);
				this.props.fireGTMTag(tagName,{
					navURL
				});
				 document.getElementById("DATA").value = response.responseObject;
				 document.acb.target =linkOpen;
				 document.acb.submit();
			}
			});
			this.showSideBarMenuClose(event);
	}

    //redirect to  package page
    handlePackage(event){
        event.preventDefault();
        const self = this;

        //check packages already in store
		self.props.fireGTMTag('Header Packages', {
			navElementText: 'Packages',
			navURL: '/packages'
		});
		browserHistory.push('/packages');
		this.showSideBarMenuClose(event);
		// } else {
        //     // call api
        //     self.props.getPackageList('accountNumber='+accountNumber +'&requestType=packages', (response) => {
		// 		const selectedPriceSource = self.props.state.user.selectedPriceSource;
        //         if(response.responseObject && response.responseObject.filter(item => item.orderHeader.salesAgreement.agreementNumber === selectedPriceSource.AGREEMENT_NUMBER.toString()).length === 0) { // if data is not found
        //             self.setState({
        //                 genericDialogHeading: 'Packages',
        //                 genericDialogText: 'No packages found for the selected Sales Agreement.',
        //                 modalButtons: 'ok',
        //                 showPackageNotFoundOverlayDialog: false
        //             }, () => {
        //                 self.setState({
        //     				showPackageNotFoundOverlayDialog: true
        //     			})
        //             })
        //             self.handleDialog('packageNotFoundOverlayDialog', true, event);
        //         } else { // if data is found
        //             // set package order asc
        //             response.responseObject = _.orderBy(response.responseObject, ['orderHeader.ponumber'], ['asc']);
        //             //Save manage order list into store
        //             self.props.savePackageList(JSON.parse(JSON.stringify(response)));
        //             //redirect to package page
		// 			self.props.fireGTMTag('Header Packages', {
		// 				navElementText: 'Packages',
		// 				navURL: '/packages'
		// 			});
        //             browserHistory.push('/packages');
        //         }
        //     });
        // }
    }

	handleSavedBrochures(event) {
		event.preventDefault();
		var self = this;
		self.setState({
			showSavedBrochuresNotFoundOverlayDialog: false
		});
		self.setHoverMenu(null)
		self.props.getSavedBrochures("userId="+self.props.state.user.userDetails.sso+"&accountNumber=" + self.props.getSelectedAccountNumber(), (response) => {
			if(!response.status) {
				self.setState({
					genericDialogHeading: 'Brochures',
					genericDialogText: 'No saved brochure found for the selected account',
					modalButtons: 'ok',
					showSavedBrochuresNotFoundOverlayDialog: true
				})
			} else {
				self.props.fireGTMTag('Header Saved Brochures');
				//redirect to saved brochures page
				browserHistory.push('/savedbrochures');
			}
		})
		this.showSideBarMenuClose(event);
	}

	handleExportProduct(event) {
		event.preventDefault();
		var self = this;
		let { state } = self.props;
		self.setHoverMenu(null);
		//If already store contains saved brochures details then redirect to view saved brochure page
		if(state.exports.priceTemplates) {
			self.props.fireGTMTag('Header Export Product & Pricing Information');
			browserHistory.push("/saved-exports");
		}
		// if data is not available
		else if(!state.exports.priceTemplates) {
			// if(self.props.state.user.userDetails) {
				self.props.getSavedExports("userId="+state.user.userDetails.sso+"&accountNumber=" + self.props.getSelectedAccountNumber(), (response) => {
					if(!response.status) {
						self.setState({
							errorMessage: response.responseMessage
						})
					} else {
						self.props.fireGTMTag('Header Export Product & Pricing Information');
						browserHistory.push("/saved-exports");
					}
				});
			// }
		}
		this.showSideBarMenuClose(event);
	}

	handlePerformanceClick(event) {
		event.preventDefault();
		var self = this;
		self.setHoverMenu(null);
		const { performanceData } = self.props.state.resources;
		//If already store contains data then no service call should be made
		let dataByAccountNumber = performanceData && performanceData.find(item => item.accountNumber === self.props.getSelectedAccountNumber());
		dataByAccountNumber = dataByAccountNumber && dataByAccountNumber.data;
		if(dataByAccountNumber) {
			self.props.fireGTMTag('Header Performance Volume Rebate Tracker');
			browserHistory.push("/resources/performance");
		}
		// if data is not available
		else if(!dataByAccountNumber) {
			self.props.getPerformanceData("requestType=pvrt&accountNumber="+self.props.getSelectedAccountNumber()+"&year=2025", response => {
				if(!response.status) {
					self.setState({
						errorMessage: response.responseMessage
					})
				} else {
					self.props.savePerformanceData({
						accountNumber: self.props.getSelectedAccountNumber(),
						data: response
					});
					self.props.fireGTMTag('Header Performance Volume Rebate Tracker');
					browserHistory.push("/resources/performance");
				}
			});
		}
		this.showSideBarMenuClose(event);
	}

	handleListClick(event) {
		event.preventDefault();
		var self = this;
		if(self.state.showSideBar){
			this.setState(prevState => ({
				showSideBar: !prevState.showSideBar
			  }));  
		}
		const { selectedAccount } = self.props.state.user;
		let skuList = [];
		this.props.state.list.list && this.props.state.list.list.responseObject && this.props.state.list.list.responseObject.wishlistItems && this.props.state.list.list.responseObject.wishlistItems.length
			&& this.props.state.list.list.responseObject.wishlistItems.forEach((item, index) => {
				if (item.itemType === 'M' || item.itemType === 'A') {
					skuList.push({ "sku": item.item });
				}
			});
		if(skuList.length <= 0 && window.location.pathname !== '/list') {
			self.props.fireGTMTag('Header List', {
				navURL: '/list'
			});
			browserHistory.push("/list");
		}
		const zipCode = self.getShippingAddressZipCode();
		zipCode && self.props.getShippingAddressesDetails(zipCode, true, 'adc_loc', resp => {
			if(resp && resp.agentid) {
				skuList.length && self.props.checkAvailabilityGeneric(skuList, `accountNumber=${selectedAccount.ACCOUNTNUMBER}&zipCode=${zipCode}&legacyCustCode=${self.props.getLegacyCustCode()}&warehouseCode=${resp.agentid}${this.props.getSalesAgreementParamForAvailability()}`, 'list', true, response => {
					if (!response.status) {
						self.setState({
							errorMessage: response.responseMessage
						});
					} else {
						self.setState({
							isAvailabilityCallCompleted: true
						}, () => {
							self.callBackAfterAll();
						});
					}
				});
			}
		});
		self.props.savePimDataForList([]);
		self.props.getPimDataForListItem(() => {
			self.setState({
				isPimCallCompleted: true
			}, () => {
				self.callBackAfterAll();
			});
		})
	}

	callBackAfterAll() {
		const self = this;
		const { isAvailabilityCallCompleted, isPimCallCompleted } = self.state;
		if(isAvailabilityCallCompleted && isPimCallCompleted && window.location.pathname !== '/list') {
			self.props.fireGTMTag('Header List', {
				navURL: '/list'
			});
			browserHistory.push("/list");
		}
	}
	getDemadClassforAgreement(agreementNumber){
		const self = this;
		const { selectedPriceSource, selectedAccountsAllPriceSources } = self.props.state.user;
		let priceSourceDetails = JSON.parse(JSON.stringify(selectedPriceSource));
		if (agreementNumber) {
			priceSourceDetails = selectedAccountsAllPriceSources.responseObject.find(item => item.AGREEMENT_NUMBER.toString() === agreementNumber.toString());
		}
		if (priceSourceDetails && priceSourceDetails["Demand Class"]) {
			return priceSourceDetails["Demand Class"];
		}
	}
	handleCartClick(event) {
		event.preventDefault();
		if(this.props.isGEAPartsSalesAgreementSelected()) {
			this.props.fireGTMTag('Header Cart', {
				navURL: '/cart'
			});
			browserHistory.push('/cart');
			return;
		}
		const self = this, { selectedAccount, selectedPriceSource } = self.props.state.user;
		if(self.state.showSideBar){
			this.setState(prevState => ({
				showSideBar: !prevState.showSideBar
			  }));  
		}
		const skuList = [];
		const servicesSkuList = [];
		const skuListForPim = [];
		self.props.state.cart.cart && self.props.state.cart.cart.responseObject && self.props.state.cart.cart.responseObject.cartItems && self.props.state.cart.cart.responseObject.cartItems.length > 0 && self.props.state.cart.cart.responseObject.cartItems.map((item, index) => {
			skuListForPim.push(item.item);
			if (item.itemType === 'M' || item.itemType === 'A')
				skuList.push({ sku: item.item, demandClass: self.getDemadClassforAgreement(item.agreementNumber) })
			else {
				if(self.props.state.cart.services_prices && !_.find(self.props.state.cart.services_prices, { itemNumber: item.item })) {
					servicesSkuList.push({ sku: item.item });
				}
			}
			return null
		});
		if(skuList.length > 0) {
			self.setState({
				isCartGetOrgAttributesCompleted: false,
				isCartPimDataCallCompleted: false,
				isCartProductPriceCallCompleted: false,
				isCartServicePriceCallCompleted: servicesSkuList.length === 0
			}, () => {
				self.props.getPimDataForCartItem((response) => {
					if(response.status) {
						const responseObject = response.responseObject ? response.responseObject : null;
						self.setState({
							isCartPimDataCallCompleted: true,
							cartPimData: responseObject
						}, () => {
							self.callBackForRedirectToCartPage('getPimDataForCartItem');
						});
					}
				})

				self.props.getOrgAttributesByAttributeName("Top Load Indicator", resp => {
					self.setState({
						isCartGetOrgAttributesCompleted: true,
					}, () => {
						self.callBackForRedirectToCartPage('getOrgAttributesByAttributeName');
					})
				});
				const zipCode = self.getShippingAddressZipCode();
				zipCode && self.props.getShippingAddressesDetails(zipCode, true, 'adc_loc', resp => {
					if(resp && resp.agentid) {
						self.props.checkAvailabilityGeneric(skuList, `accountNumber=${selectedAccount.ACCOUNTNUMBER}&zipCode=${zipCode}&legacyCustCode=${self.props.getLegacyCustCode()}&warehouseCode=${resp.agentid}${this.props.getSalesAgreementParamForAvailability()}`, 'cart', true, response => {
							let isPricingAccess = self.props.isResponsibilityExists("Price");
							if (isPricingAccess) {
								self.props.makeParallelCallsForCartPrices(self.props.state.cart.cart.responseObject.cartItems, true, true, 'cart', null, () => {
									self.setState({
										isCartProductPriceCallCompleted: true
									}, () => {
										self.callBackForRedirectToCartPage('makeParallelCallsForCartPrices');
									});
								});
								const pricingEffectiveDate = moment().tz('America/New_York').format('YYYYMMDD');
								var servicesPayload = []
								// fetch site id from SOLD_TO to address
								const soldToAddresses = self.props.getAddressesByCategory('SOLD_TO');
								let state = 'NA';
								let whse = 'NA';
								let zone = 'NA'
								if (soldToAddresses.length > 0) {
									state = soldToAddresses[0].STATE;
								}
								self.props.getShippingAddressesDetails(zipCode, false, 'sds_loc', resp => {
									if (resp) {
										whse = resp.agentid;
										zone = resp.sdsApZone;
										const { salesAgreementNumber, accountNumber } = self.props.checkForTokenAccountByMasterSA(selectedPriceSource, selectedAccount.ACCOUNTNUMBER);
										servicesSkuList.length > 0 && servicesSkuList.map((item, index) => {
											return servicesPayload.push({
												pricingEffectiveDate: pricingEffectiveDate,
												accountNumber,
												state: self.getShippingAddressState() || state,
												zone: zone,
												whse: whse,
												salesAgreementNumber,
												itemNumber: item.sku
											});
										});
										if(servicesPayload.length > 0) {
											self.props.checkServicesPricesForCartPage({ items: servicesPayload }, `requestType=servicesPricing`, response => {
												self.setState({
													isCartServicePriceCallCompleted: true,
												}, () => {
													self.callBackForRedirectToCartPage('checkServicesPricesForCartPage');
												});
											});
										}
									}
								});
							} else {
								self.setState({
									isCartProductPriceCallCompleted: true,
									isCartServicePriceCallCompleted: true,
								}, () => {
									self.callBackForRedirectToCartPage('checkAvailabilityGeneric else');
								});
							}
						});
					}
				});
			});
		} else {
			self.props.fireGTMTag('Header Cart', {
				navURL: '/cast'
			});
			browserHistory.push('/cart');
		}
	}

	callBackForRedirectToCartPage(funcName) {
		const self = this;
		const {
			isCartGetOrgAttributesCompleted,
			isCartPimDataCallCompleted,
			isCartProductPriceCallCompleted,
			isCartServicePriceCallCompleted
		} = self.state;
		if(isCartGetOrgAttributesCompleted && isCartPimDataCallCompleted && isCartProductPriceCallCompleted && isCartServicePriceCallCompleted) {
			// let attributeName = "geego_no_top_load";
			// self.props.getOrgAttributesByAttributeName("Top Load Indicator", resp => {
			// 	if(resp) {
			// 		attributeName = "geego_top_load";
			// 	}
			// 	self.props.updateCartOrderPoints({pimData: self.state.cartPimData, attributeName});
				self.props.fireGTMTag('Header Cart', {
					navURL: '/cast'
				});
				browserHistory.push("/cart");
			// });
		}
	}

	handleMonogramClick(event) {
		event.preventDefault();
		var self = this;
		self.setHoverMenu(null);
		const { monogramData } = self.props.state.resources;
		//If already store contains data then no service call should be made
		let dataByAccountNumber = monogramData && monogramData.find(item => item.accountNumber === self.props.getSelectedAccountNumber());
		dataByAccountNumber = dataByAccountNumber && dataByAccountNumber.data;
		if(dataByAccountNumber) {
			self.props.fireGTMTag('Header Monogram Volume Rebate Tracker');
			browserHistory.push("/resources/monogram");
		}
		// if data is not available
		else if(!dataByAccountNumber) {
			self.props.getMonogramData("requestType=mvrt&accountNumber="+self.props.getSelectedAccountNumber()+"&year=2025", response => {
				if(!response.status) {
					self.setState({
						errorMessage: response.responseMessage
					})
				} else {
					self.props.saveMonogramData({
						accountNumber: self.props.getSelectedAccountNumber(),
						data: response
					});
					self.props.fireGTMTag('Header Monogram Volume Rebate Tracker');
					browserHistory.push("/resources/monogram");
				}
			});
		}
		this.showSideBarMenuClose(event);
	}

	handleGEAdBuilder(event) {
		event.preventDefault();
		var self = this;
		self.setHoverMenu(null);
		const { state } = self.props;
		const { userDetails, geAdBuilderData } = state.user;
		//If already store contains data then no service call should be made
		document.ad_builder.target = '_blank';
		document.ad_builder.action = adBuilderActionURL;
		if(geAdBuilderData) {
			document.getElementById('ad_builder_data').value = geAdBuilderData.responseObject;
			document.ad_builder.submit();
		}
		// if data is not available
		else {
			self.props.getGEAdBuilderKey(`requestType=geadBuilder&legacyCustCode=${self.props.getLegacyCustCode()}&userType=${userDetails.typeOfUser}&userId=${userDetails.sso}&accountNumber=${self.props.getSelectedAccountNumber()}`, (response) => {
				document.getElementById('ad_builder_data').value = response.responseObject;
				document.ad_builder.submit();
			});
		}
	}

	showPriceSelectionOverlayDialog(dialogName, event) {
		event.preventDefault();
		const self = this;
		self.handleDialog(dialogName, true);
	}

	handleMyProfileClick(event) {
		event.preventDefault();
		//Make call to get profile details
		var self = this;
		if(self.state.showSideBar){
			this.setState(prevState => ({
				showSideBar: !prevState.showSideBar
			  }));  
		}
		let { user } = self.props.state;
		if(user.userDetails.typeOfUser === 'customer' && !user.localUserDetails) {
			self.props.getLocalUserDetails(`userId=${user.userDetails.sso}&requestType=getLocalUser`, response => {
				if(response.status) {
					self.props.fireGTMTag('Header My Profile',{
						navURL: '/profile/myProfile'
					});
					browserHistory.push('/profile/myProfile');
				} else {
					browserHistory.push('/error');
				}
			});
		} else {
			self.props.saveMobileView(false);
			self.props.fireGTMTag('Header My Profile',{
				navURL: '/profile/myProfile'
			});
			browserHistory.push('/profile/myProfile');
		}
	}

	handleSalesAgreement(event) {
		event.preventDefault();
		this.setHoverMenu(null);
		//If already store contains saved brochures details then redirect to view saved brochure page
		if(this.props.state.resources.salesAgreementHandBook) {
			browserHistory.push("/resources/salesHandbooks");
		} else {
			this.props.getSalesAgreementHandBook('requestType=handbooks', response => {
				if(response.status) {
					browserHistory.push("/resources/salesHandbooks");
				} else {
					browserHistory.push("/error");
				}
			});
		}
	}

	checkForBackOrdersAndBulkOrderHold(event) {
		event.preventDefault();
		const self = this;
		// if user clicked again on back orders available link
		self.props.resetParallelCallsOrderDetails();
		self.props.saveBackOrders(null);
		self.props.saveBulkOrdersHold(null);
		self.props.fireGTMTag('Header Backorders Available',{
			navURL: '/backOrders'
		});
		browserHistory.push('/backOrders');
		// self.props.checkForBackOrders(self.props.getSelectedAccountNumber(), true, response => {
		// 	self.setState({
		// 		backOrderCallCompleted: true
		// 	}, () => {
		// 		self.callBackAfterCallsCompleted();
		// 	});
		// });
		// self.props.checkForBulkOrdersHold(self.props.getSelectedAccountNumber(), true, response => {
		// 	self.setState({
		// 		bulkOrderHoldCallCompleted: true
		// 	}, () => {
		// 		self.callBackAfterCallsCompleted();
		// 	});
		// });
	}

	// callBackAfterCallsCompleted() {
	// 	const self = this;
	// 	const { backOrderCallCompleted, bulkOrderHoldCallCompleted } = self.state;
	// 	if(backOrderCallCompleted && bulkOrderHoldCallCompleted) {
	// 		self.props.fireGTMTag('Header Backorders Available',{
	// 			navURL: '/backOrders'
	// 		});
	// 		browserHistory.push('/backOrders');
	// 	}
	// }

	handleAutoSuggests(flag) {
		var self = this;
		setTimeout(function() {
			self.setState({
				showSuggestion: flag
			});
		}, 200);
	}

	validateSearchKeyword(event) {
        var value = event.target.value,
            lastCharacter = value.substring(value.length-1),
            lastKeyword = value.split(" "),
            noOfSpace = value.split(" ").length;

        this.setState({
            productNumberError: ""
        });
        //(lastCharacter === " ")?lastKeyword.pop():'';
        lastKeyword = lastKeyword[lastKeyword.length-1];
        if((value === "" && event.charCode === 32 )||
            (lastCharacter === " " && lastKeyword !== "")||
            (lastKeyword.length < 3 && event.charCode === 32)||
            (noOfSpace === 5 && event.charCode === 32 )||
            noOfSpace===6) {
            event.preventDefault();
        }
        var errorMsg = "";
        if((noOfSpace === 5 && event.charCode === 32 )||noOfSpace===6) {
            errorMsg = "You can only enter 5 keywords separated by space."
        }
        if(lastCharacter === " " && lastKeyword !== "") {
            errorMsg = "There should be only one space between each keyword."
        }
        if(value === "" && event.charCode === 32) {
            errorMsg = "Keyword can not be start with space character."
        }
        if(lastKeyword.length < 3 && event.charCode === 32) {
            errorMsg = "Please enter valid minimum 3 characters in each keyword."
        }
        this.setState({
            productNumberError: errorMsg
        });
    }

	handleChangeProductNumber(event) {
		const self = this;
		self.setState({
			showSearchLoading: false,
			showSuggestion: false
		});
        let value = event.target.value,
            lastCharacter = value.substring(value.length-1),
            lastKeyword = event.target.value.split(" ");
        if(lastCharacter === " ")lastKeyword.pop();
        lastKeyword = lastKeyword[lastKeyword.length-1];

        //save all search string in store for showing next result page
		self.props.savePostLoginSearchKeyword(value);

        //Check if last character is space or not
        if(lastCharacter === " " || lastKeyword.length <= 2) {
            //in case of space reset suggestion list
            self.props.resetSearchKeywordSuggestionList();
        } else if(lastKeyword !== "" && lastKeyword.length > 2) {
			self.setState({showSearchLoading: true, showSuggestion: true});
			self.props.saveSearchKeywordSuggestionList(null);
			const { selectedAccount, selectedPriceSource } = self.props.state.user;
			if(self.state.showSearchMobileSection){
				self.productNumberInput.value = value;
			}
            self.props.getSearchKeywordSuggestionList(`requestType=getItems&keyword=${self.productNumberInput.value.trim()}&count=${getItemsCount}&accountNumber=${selectedAccount.ACCOUNTNUMBER}&zipCode=${self.props.customZipCode}&page=search`, response => {
				if(self.productNumberInput.value.replace(' ','+').toUpperCase().trim() === response.keyword.toUpperCase().replace(/\*/g,'')) {
					self.setState({
						searchKeywordSuggestionResult: response
					})
					// Make availability call
					let skuList = response.responseObject;
					skuList = skuList.map(item => {
						return { sku: item.sku };
					});
					if(skuList.length > 0) {
						// const data = JSON.parse(self.props.state.user.selectedAddress);
						const zipCode = self.props.customZipCode;
						zipCode && self.props.getShippingAddressesDetails(zipCode, true, 'adc_loc', resp => {
							if(resp && resp.agentid) {
								// reset keyword result list, availability list, and prices list
								const headerSelectedAddress = JSON.parse(self.props.state.user.selectedAddress);
								const {
									STATE,
									COUNTRY,
								} = headerSelectedAddress || {};
								self.props.checkAvailabilityAndOrderability2(skuList, `accountNumber=${selectedAccount.ACCOUNTNUMBER}&zipCode=${zipCode}&legacyCustCode=${self.props.getLegacyCustCode()}&warehouseCode=${self.props.customADC}${this.props.getSalesAgreementParamForAvailability()}`, `&country=${COUNTRY}&state=${STATE}&zip=${zipCode}`, '', false, resp => {
									self.setState({
										suggestionAvailabilityCallCompleted: true,
										suggestionAvailabilityResult: resp.responseObject
									}, () => {
										self.saveSearchKeywordResultToStore();
									})
								});
							}
						}, false);
					} else {
						self.setState({
							suggestionAvailabilityCallCompleted: true,
							suggestionAvailabilityResult: []
						}, () => {
							self.saveSearchKeywordResultToStore();
						})
					}
					//Make call for pricing
					const pricingEffectiveDate = moment().tz('America/New_York').format('YYYYMMDD');
					let payload = response.responseObject;
					payload = payload.map(item => item.sku);
					if(payload.length > 0) {
						self.props.checkPricesForSearchResult({
							account_number: selectedAccount.ACCOUNTNUMBER,
							pricing_effective_date: pricingEffectiveDate,
							sa_number: selectedPriceSource.AGREEMENT_NUMBER.toString(),
							item_numbers: payload
						}, false, false, resp => {
							resp = self.props.processPricingResponse(resp);
							let result = resp.responseObject && resp.responseObject.items?resp.responseObject.items:[];
							result.forEach(item => {
								item.records = _.filter(item.records, { orderable: "Y"});
							});
							self.setState({
								suggestionPricingCallCompleted: true,
								suggestionPricingResult: result
							}, () => {
								self.saveSearchKeywordResultToStore();
							});
						});
					} else {
						self.setState({
							suggestionPricingCallCompleted: true,
							suggestionPricingResult: []
						}, () => {
							self.saveSearchKeywordResultToStore();
						});
					}
				}
			});
        }
    }

	saveSearchKeywordResultToStore(data) {
		if(this.state.suggestionAvailabilityCallCompleted && this.state.suggestionPricingCallCompleted) {
			var self = this;
			const finalData = [];
			this.state.searchKeywordSuggestionResult.responseObject.forEach(item => {
				const isAvailable = self.state.suggestionAvailabilityResult ? _.find(self.state.suggestionAvailabilityResult, {sku: item.sku}) : null;
				const isPriceAvailable = self.state.suggestionPricingResult ? _.find(self.state.suggestionPricingResult, {item_number: item.sku}) : null;
				if(isAvailable && isPriceAvailable && isPriceAvailable.records.length > 0) {
					finalData.push({
						...item,
						availableQty: isAvailable.availableQty,
						etaDate: isAvailable.etaDate,
						intransitQty: isAvailable.intransitQty,
					});
				}
			});
			finalData = finalData.filter(item => {
				return !self.props.checkIfFP(item) && item.lifeCyclePhase !== "Near End of Life";
			});
			if(true) {
				self.props.saveSearchKeywordSuggestionList(_.chunk(finalData, 5).length > 0 ? _.chunk(finalData, 5)[0] : []);
				self.setState({
					showSearchLoading: false,
					suggestionAvailabilityCallCompleted: false,
					suggestionPricingCallCompleted: false
				});
			}
		}
	}

	handleSelectSuggestion(label, event) {
		const self = this;
		let { state } = this.props;
		event.preventDefault();
		var currentValue = this.productNumberInput.value.trim().split(" ");
		currentValue.pop();
		currentValue.push(label);
		currentValue = currentValue.join(" ").trim();
		// //in case of space reset suggestion list
		// dispatch(resetSearchKeywordSuggestionList());
		// this.setState({showSuggestion: false});
		//save all search string in store for showing next result page
        self.props.savePostLoginSearchKeyword(currentValue);
		this.productNumberInput.value = currentValue;

		//Update suggestion list as per selected keyword
		self.props.saveSearchKeywordSuggestionList(_.filter(state.searchKeyword.productNumberList, ["sku", label]));
	}

	handleSkuClick(sku, event) {
		event.preventDefault();
		browserHistory.push("/product-specs/product-number/"+sku);
	}

	handleSearchSubmit(event) {
		event.preventDefault();
		const self = this;
		//Reset product Line
		this.props.updateFromWhereProductLineClicked('Search_Button');
		self.props.saveProductLine('');
		self.props.fireGTMTag('Product Number Search', {
			searchTerm: self.productNumberInput.value.trim(),
			searchType: 'product'
		});
		if(window.location.href.toLowerCase() !== `${window.location.origin}/search-result/product-number/${encodeURI(self.productNumberInput.value.toLowerCase().trim())}`) {
			if(self.productNumberInput.value.trim() !== "") {
				self.props.resetProductAvailabilityResultList();
				browserHistory.push("/search-result/product-number/"+ encodeURI(self.productNumberInput.value.trim()));
			}
		}
	}

	handleQuoteModelSubmit(event) {
		event.preventDefault();
		const self = this;
		// Reset product Line
		self.props.saveProductLine('');
		// self.props.fireGTMTag('Quote Model Search', {
		// 	searchTerm: self.productNumberInput.value.trim(),
		// 	searchType: 'quote'
		// });
		// if(window.location.href.toLowerCase() !== `${window.location.origin}/search-result/product-number/${encodeURI(self.productNumberInput.value.toLowerCase().trim())}`) {
			// if(self.productNumberInput.value.trim() !== "") {
			if(window.location.pathname !== '/search-result/quote-models') {
				self.props.resetProductAvailabilityResultList();
				browserHistory.push("/search-result/quote-models");
			}
			// }
		// }
		this.showSideBarMenuClose(event);
	}

	handleManageOrder(event) {
		event.preventDefault();
		this.props.saveManageOrdersListBackup(null);
		this.setHoverMenu(null);
		this.props.fireGTMTag('Header Manage Orders');
		browserHistory.push("/manageorders");
		this.showSideBarMenuClose(event);
	}

	handleRequestReturn(event) {
		event.preventDefault();
		this.setHoverMenu(null);
		this.props.fireGTMTag('Header Request Return');
		browserHistory.push("/requestreturn");
		this.showSideBarMenuClose(event);
	}
	handleRequestCredit(event) {
		event.preventDefault();
		this.setHoverMenu(null);
		this.props.fireGTMTag('Header Request Credit');
		browserHistory.push("/requestcredit");
		this.showSideBarMenuClose(event);
	}
	handleQuickOrder(event) {
		event.preventDefault();
		this.setHoverMenu(null);
		this.props.fireGTMTag('Header Quick Order');
		browserHistory.push("/quickorder");
		this.showSideBarMenuClose(event);
	}

	handleNCRPOrder(event) {
		event.preventDefault();
		this.setHoverMenu(null);
		this.props.fireGTMTag('Header No Charge Replacement Parts');
		browserHistory.push("/ncrp-order");
		this.showSideBarMenuClose(event);
	}

	handleViewReturnsAndCredits(event) {
		event.preventDefault();
		this.props.saveViewRequestsListBackup(null);
		this.setHoverMenu(null);
		this.props.fireGTMTag('Header View Returns & Credits');
		browserHistory.push("/viewrequests");
		this.showSideBarMenuClose(event);
	}

	handleChangeAddress(event) {
		const self = this;
		const value = event.target.value;
		const selectedAddress = JSON.parse(value);
		const zipCode = selectedAddress.POSTALCODE && selectedAddress.POSTALCODE.split('-')[0];
		localStorage.setItem("zipCodeChanged", false);
		this.props.saveCustomZipCode(zipCode);
		self.props.updateSelectedAddress(value);
		self.props.setDefaultADC(JSON.parse(value), self.props.getSelectedAccountNumber());
	}

	handlePriceSheets(event) {
		event.preventDefault();
		const self = this;
		self.props.getPriceSheets(() => {
			self.props.fireGTMTag('Header Price Sheets');
			browserHistory.push("/resources/pricesheets");
		});
		self.setHoverMenu(null);
		this.showSideBarMenuClose(event);
	}
	handleAdvertisingPortal(event) {
		event.preventDefault();
		const self = this;
		self.props.fireGTMTag('Header Advertising Portal');
		browserHistory.push("/resources/advertisingportal");
	}

	handleChangeADC(event) {
		this.props.setSelectedADC(event.target.value);
		this.props.saveCustomADC(event.target.value);
	}

	handleViewInvoices(event) {
		event.preventDefault();
		const self = this;
		self.props.fireGTMTag('Header View Invoices');
		browserHistory.push("/viewinvoices");
		self.setHoverMenu(null);
		this.showSideBarMenuClose(event);
	}
	
	showSideBarMenuClick(event){
		event.preventDefault();
		const self = this;
		self.setState({
			showSideBar: true
		});  
	}
	
	showSideBarMenuClose(event){
			event.preventDefault();
			const self = this;
			self.setState({
				showSideBar: false
			}); 
		self.props.saveMobileView(false);
	}
	showSearchSection(event){
		event.preventDefault();
		this.setState(prevState => ({
			showSearchMobileSection: !prevState.showSearchMobileSection,
		})); 
	}

	handleGetPartsCatalog = event => {
		event.preventDefault();
		const queryString = `requestType=getPartsCatlog&${PNET_APP_QUERY_PARAM}`;
	
		this.props.getFileURL(resources.partsCatalog.path, queryString, partsCatalogDocumentURLResponse => {
			if (partsCatalogDocumentURLResponse.status) {
				partsCatalogDocumentURLResponse.responseObject && window.open(partsCatalogDocumentURLResponse.responseObject);
			}
		});
	}

	handleGetMultiPackFile = event => {
		event.preventDefault();
		const subAccountClassification = this.props.state.user.selectedPriceSource['Sub Account Classification'] || '';
		const queryString = `requestType=getMultiPackFile&subClass=${subAccountClassification.split('-').at(-1)}&${PNET_APP_QUERY_PARAM}`;
	
		this.props.getFileURL(resources.multiPackFile.path, queryString, multiPackFileURLResponse => {
			if (multiPackFileURLResponse.status) {
				multiPackFileURLResponse.responseObject && window.open(multiPackFileURLResponse.responseObject);
			}
		});
	}

	handleGetWeightAndDimensionsFile = event => {
		event.preventDefault();
		const queryString = `requestType=getWeightAndDimensionsFile&${PNET_APP_QUERY_PARAM}`;
	
		this.props.getFileURL(resources.weightAndDimensionsFile.path, queryString, weightAndDimensionsFileURLResponse => {
			if (weightAndDimensionsFileURLResponse.status) {
				weightAndDimensionsFileURLResponse.responseObject && window.open(weightAndDimensionsFileURLResponse.responseObject);
			}
		});
	}

	handleGetPartsPricingFile = event => {
		event.preventDefault();
		browserHistory.push('/resources/pricesheets');
	}

	clearPartsSearchData = () =>{
		this.partsNetSearchBoxRef && this.partsNetSearchBoxRef()
	}

	handleSearchByStoreNumberOrLocation = e => {
		e.preventDefault();
		this.handleDialog('AddressSearchDialog', true);
	};

	handleAddressSelection = address => {
		const { selectedAccount, selectedAddressBackup } = this.props.state.user;
		if (!selectedAddressBackup || selectedAddressBackup.SITE_USE_ID !== address.SITE_USE_ID) {
			this.props.saveSelectedAddressBackup(address);
		}
		const zipCode = address.POSTALCODE && address.POSTALCODE.split('-')[0];
		localStorage.setItem('zipCodeChanged', false);
		this.props.updateSelectedAddress(JSON.stringify(address));
		this.props.saveCustomZipCode(zipCode);
		this.props.setDefaultADC(address, selectedAccount.ACCOUNTNUMBER);
		this.handleDialog('AddressSearchDialog', false);
	};

    render() {
		const self = this;
		const isPricingAccess = this.props.isResponsibilityExists("Price");
		//const { isCanadianZipCode } = self.props;
		const { user, product, order, list, cart } = this.props.state;
		const { selectedAccount, selectedPriceSource, usersOfAccount, userDetails, relationShipPartyList } = user;
		const typeOfUser = userDetails ? userDetails.typeOfUser : '';
		const isThisAccountRestricted = this.props.isThisAccountRestricted;
		let isPendingRequests = false;
		const  exceptionPartyId  = relationShipPartyList && relationShipPartyList.exceptionPartyId;

		const isInvoicesAndPaymentAccess = this.props.isResponsibilityExists("Invoices and Payments");
		const isViewOrdersAccess = this.props.isResponsibilityExists("View Orders");
		const isViewReportsAccess = this.props.isResponsibilityExists("View Reports");
		const isViewReturnsCreditAccess = this.props.isResponsibilityExists("Returns/Credits");
		if(usersOfAccount && selectedAccount) {
			usersOfAccount.responseObject && usersOfAccount.responseObject.forEach(item => {
				if(!isPendingRequests) {
					if(_.find(item.accounts, {approvalStatus: 'Pending', accountNumber: selectedAccount.ACCOUNTNUMBER})) {
						isPendingRequests = true;
					}
				}
				return null;
			});
		}
		let listCount = 0,
			cartCount = 0;
		if(list && list.list && list.list.responseObject && list.list.responseObject.wishlistItems) {
			listCount = list.list.responseObject.wishlistItems.length;
		}
		if(cart && cart.cart && cart.cart.responseObject && cart.cart.responseObject.cartItems) {
			cart.cart.responseObject.cartItems.forEach(itm => {
				cartCount += parseInt(itm.quantity, 10);
			});
		}
		const typeOfAccount = self.props.getSelectedAccountType();

		const shipToAddressList = self.props.getCombinedAddresses(true).filter(item => item.PURPOSE === 'SHIP_TO');
		const { adcList } = self.props.state.user;
		const isAllowPunchOutAccess = self.props && self.props.state && self.props.state.user && self.props.state.user.userDetails && self.props.state.user.userDetails.punchOutAccess;
		const isGEAPartsSalesAgreementSelected = self.props.isGEAPartsSalesAgreementSelected();
		const isRetailSalesChannelCode = selectedAccount && selectedAccount.SALESCHANNELCODE=='RETAIL' ? true : false;
		const isRetailAndContractSalesChannelCode = selectedAccount && selectedAccount.SALESCHANNELCODE=='RETAIL' || selectedAccount && selectedAccount.SALESCHANNELCODE == 'CONTRACT' ? true : false;
        return (
			<div>
			<nav ref={this.setWrapperRef} className={this.state.showSideBar ?"d-block d-sm-none sideBarNav":"d-block d-sm-none mobileNav"}>
						<ul className={this.state.showSideBar?"sideBarUl sidebar":"sidebarHide"}>
						{<li>
							<div style={{paddingLeft:"13rem", marginTop:"1rem"}}><svg   onClick={this.showSideBarMenuClose.bind(this)} xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 -960 960 960" width="30" fill="#e8eaed">
									<path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/>
									</svg></div>
							</li>}
							<div className="sideBarHr"></div>
							<div style={{padding:"2rem"}}>
								{!isAllowPunchOutAccess &&	
								<li className='sideBarList'>
									<svg viewBox="0 0 31.5 36" height="20" width="20" fill="#86bbe4">
										<path d="m31.5,33.56c0,1.35-1.09,2.44-2.44,2.44H2.44c-1.35,0-2.44-1.09-2.44-2.44,0-6.73,5.46-12.19,12.19-12.19h7.13c6.73,0,12.19,5.46,12.19,12.19ZM6.75,9C6.75,4.03,10.78,0,15.75,0s9,4.03,9,9-4.03,9-9,9S6.75,13.97,6.75,9Z">
										</path>
									</svg>
									<div style={{display:"inline-flex", paddingLeft:"1rem"}} className={user.userDetails && (user.userDetails.isNonGEASsoUser ? user.userDetails.isManRepSsoUser : (user.userDetails.isAdmin || user.userDetails.isASM || user.userDetails.isInDL)) && 
										isPendingRequests?"importantText bold":""} onClick={this.handleMyProfileClick}>My Profile</div>
								</li>}
								{!isGEAPartsSalesAgreementSelected && !isAllowPunchOutAccess &&
										<li className="sideBarList">
											<svg viewBox="0 0 28 28" height="20"  width="20" fill="#86bbe4">
												<path d="M6 22c0 1.656-1.344 3-3 3s-3-1.344-3-3 1.344-3 3-3 3 1.344 3 3zM6 14c0 1.656-1.344 3-3 3s-3-1.344-3-3 1.344-3 3-3 3 1.344 3 3zM28 20.5v3c0 0.266-0.234 0.5-0.5 0.5h-19c-0.266 0-0.5-0.234-0.5-0.5v-3c0-0.266 0.234-0.5 0.5-0.5h19c0.266 0 0.5 0.234 0.5 0.5zM6 6c0 1.656-1.344 3-3 3s-3-1.344-3-3 1.344-3 3-3 3 1.344 3 3zM28 12.5v3c0 0.266-0.234 0.5-0.5 0.5h-19c-0.266 0-0.5-0.234-0.5-0.5v-3c0-0.266 0.234-0.5 0.5-0.5h19c0.266 0 0.5 0.234 0.5 0.5zM28 4.5v3c0 0.266-0.234 0.5-0.5 0.5h-19c-0.266 0-0.5-0.234-0.5-0.5v-3c0-0.266 0.234-0.5 0.5-0.5h19c0.266 0 0.5 0.234 0.5 0.5z"></path>
											</svg>
											<div style={{display:"inline-flex", paddingLeft:"1rem"}} onClick={this.handleListClick.bind(this)}>List {`(${listCount})`}</div>
										</li>
									}
								<li className="sideBarList">
								<svg viewBox="0 0 122.36 110.62" height="20"  width="20" fill="#86bbe4">
										<path d="M28.77,15.46s82.13,.15,90.34,.15h1.04c1.61,.58,2.52,2.28,2.11,3.94l-10.43,48.97c-.29,1.53-1.64,2.62-3.19,2.57l-66.28,.06,4.45,17.49c4.7,.25,8.75,3.39,10.15,7.88l28.47,.15c1.6-5.88,7.67-9.35,13.55-7.74,5.88,1.6,9.35,7.67,7.74,13.55-1.31,4.82-5.7,8.15-10.69,8.13-4.82,.04-9.08-3.11-10.44-7.73l-28.82-.15c-1.34,4.66-5.59,7.87-10.44,7.88-6.07,.04-11.03-4.84-11.08-10.91,0-3.92,2.08-7.55,5.46-9.54-6.64-28.01-13.76-55.92-20.57-83.95H3.16C1.48,6.28,.06,4.96,0,3.27c0-.03,0-.06,0-.09C-.05,1.48,1.29,.05,3,0c.06,0,.11,0,.17,0H22.57c1.52-.04,2.82,1.07,3.03,2.58l3.16,12.88h.01Z" />
									</svg>
									<div style={{display:"inline-flex", paddingLeft:"1rem"}} onClick={this.handleCartClick.bind(this)}>Cart {`(${cartCount})`}</div>
								</li>
								<div className="sideBarList">
								<svg  height="20" viewBox="0 -960 960 960" width="20" fill="#86bbe4">
										<path d="M478-240q21 0 35.5-14.5T528-290q0-21-14.5-35.5T478-340q-21 0-35.5 14.5T428-290q0 21 14.5 35.5T478-240Zm-36-154h74q0-33 7.5-52t42.5-52q26-26 41-49.5t15-56.5q0-56-41-86t-97-30q-57 0-92.5 30T342-618l66 26q5-18 22.5-39t53.5-21q32 0 48 17.5t16 38.5q0 20-12 37.5T506-526q-44 39-54 59t-10 73Zm38 314q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
									</svg>
									<div style={{display:"inline-flex", paddingLeft:"1rem"}} onClick={this.handleGetHelpDocumentsURL.bind(this, 'requestType=help')}>Help</div>
								</div>
								{!isAllowPunchOutAccess &&
								<div className="sideBarList">
									<svg viewBox="0 0 512 512" height="20"  width="20" fill="#86bbe4">
										<path d="M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"/>
									</svg>
									<div style={{display:"inline-flex", paddingLeft:"1rem"}} onClick={this.props.logout}>Logout</div>
								</div>}
							</div>
			
							<div className="sideBarHr"></div>
							<div className="accordion accordion-flush w-100" id="accordionProduct">
								{!isGEAPartsSalesAgreementSelected && <div className="accordion-item accordionTopNavItem">
									<h2 className="accordion-header" id="product-headingOne">
										<button className={`accordion-button ${this.state.showSideBar?'collapsed':''} accordionTopNavButton sideBarButton`} type="button" 
										data-bs-toggle="collapse" data-bs-target="#product-collapseOne" aria-expanded="false" aria-controls="product-collapseOne">
											Products / Availability
										</button>
									</h2>
									<div id="product-collapseOne" className={`accordion-collapse collapse ${this.state.showSideBar?'':'show'}`} aria-labelledby="product-headingOne" 
									data-bs-parent="#accordionProduct">
										<div className="accordion-body accBodyNotCollapsed">
											<div className="flyoutWrapper">
												<ul className="flyout mobileFlyout">
													{/* packages will only for contract user, show in top */}
													{typeOfAccount === 'CONTRACT' &&
														<li><a href="#" onClick={this.handlePackage.bind(this)}>Packages</a></li>
													}
													{selectedPriceSource && selectedPriceSource['Quote Type'] === 'Q' && <li>
														<a href="" onClick={this.handleQuoteModelSubmit.bind(this)}>Quote Models</a>
													</li>}
													{product.productLineList.map((item, index) =>{
														if (item.name === 'HVAC') {
																return <li key={index} onMouseEnter={this.handleMainCategoryHover.bind(this)}
																			onMouseLeave={this.handleMainCategoryLeave.bind(this)} >
																			
																			<a href="#">{item.name}</a>
																				{this.state.showSubcategories && item.subCategory && (
																					<ul>
																						{item.subCategory.map((subItem, subIndex) => (
																							<li key={subIndex} style={{ marginBottom: '20px' }}>
																							<a  style={{color:'black',textDecoration:'none' }}
																								href="#"
																								onClick={this.redirectProductLineSearch.bind(this, "?N=" + subItem.categoryId, subItem.name)}>
																								{subItem.name}
																							</a>
																							</li>
																						))}
																					</ul>
																				)}
																		</li>
															}
															else{
																return <li key={index}>
																			<a href="" onClick={this.redirectProductLineSearch.bind(this, "?N=" + item.categoryId, item.name)}>{item.name}
																			</a>
																		</li>
															}
													})}
													{(typeOfAccount === 'RETAIL' || this.props.customerClassCodeOfSelectedAccount === 'APPLIANCE BUILDER DISTRIBUTOR' ||  this.props.customerClassCodeOfSelectedAccount === 'APARTMENT REPLACEMENT DIST' ||
													this.props.customerClassCodeOfSelectedAccount === 'AWS PRO - DISTRIBUTORS' || this.props.customerClassCodeOfSelectedAccount === 'HOSPITALITY DISTRIBUTOR') &&
														<li><a href="" onClick={this.redirectProductLineSearch.bind(this, "?N=4294966743", "Closeouts")}>Closeouts</a></li>
													}
													{(typeOfAccount === 'RETAIL' || typeOfAccount === 'PRO CHANNEL' || typeOfAccount === 'HQ') &&
														<li><a href="#" onClick={this.handlePackage.bind(this)}>Packages</a></li>
													}
												</ul>
											</div>
										</div>
									</div>
								</div>}
								<div className="accordion-item accordionTopNavItem">
									<h2 className="accordion-header" id="flush-tools">
										<button className={`accordion-button ${this.state.showSideBar?'collapsed':''} accordionTopNavButton sideBarButton`} type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwoTools" aria-expanded="false" aria-controls="flush-collapseTwoTools">
											Tools
										</button>
									</h2>
									<div id="flush-collapseTwoTools" className={`accordion-collapse collapse ${this.state.showSideBar?'':'show'}`} aria-labelledby="flush-tools" data-bs-parent="#accordionProduct">
										<div className="accordion-body accBodyNotCollapsed">
										{isAllowPunchOutAccess ? 
											<div className="flyoutWrapper">
												<ul className="flyout mobileFlyout">
													<li><a href="" onClick={this.handleManageOrder.bind(this)}>Manage Orders</a></li>
												</ul> 
											</div> :
											!isThisAccountRestricted && <div className="flyoutWrapper">
											<ul className="flyout mobileFlyout">
												{isViewOrdersAccess && <li><a href="" onClick={this.handleManageOrder.bind(this)}>Manage Orders</a></li>}
												<li><a href="" onClick={this.handleQuickOrder.bind(this)}>Quick Order{isGEAPartsSalesAgreementSelected && ' / Availability'}</a></li>
												{!isGEAPartsSalesAgreementSelected && <React.Fragment>
													{self.props.hasRequestReturnAccess && <li><a href="" onClick={this.handleRequestReturn.bind(this)}>Request Return</a></li>}
													{self.props.hasRequestCreditAccess && <li><a href="" onClick={this.handleRequestCredit.bind(this)}>Request Credit</a></li>}
													{isViewReturnsCreditAccess && <li>
														<a href="" onClick={this.handleViewReturnsAndCredits.bind(this)}>View Returns & Credits</a>
													</li>}
													{self.props.isEmployeeHasAccessTo('Approve Returns') &&
														<li>
															<a href="" onClick={this.handleApproveReturns.bind(this)}>Approve Returns and Credits</a>
														</li>
													}
												</React.Fragment>}
												{isInvoicesAndPaymentAccess && <li><a href="" onClick={this.handleViewInvoices.bind(this)}>View & Print Invoices</a></li>}
												{isInvoicesAndPaymentAccess && <li><a onClick={this.handleRedirection.bind(this, typeOfUser === 'customer'?searchAndPayInvoicesURLCust:searchAndPayInvoicesURLEmp, 'Header Search & Pay Invoices', '_blank', false)} href="">Search & Pay Invoices</a></li>}
												{!isGEAPartsSalesAgreementSelected && <React.Fragment>
													<li><a href="" onClick={this.handleRedirection.bind(this, '/carrierinformation', 'Header Carrier Information', '', true)}>Carrier Information</a></li>
													{isPricingAccess && <li><a href="" onClick={this.handleCreatePackage.bind(this)}>Create Package</a></li>}
													<li><a href="" onClick={this.handleCreateBrochureDialog.bind(this, 1)}>Create Brochure</a></li>
													<li><a href="" onClick={this.handleSavedBrochures.bind(this)}>Saved Brochures</a></li>
													<li><a href="" onClick={this.handleCreatePriceTags.bind(this)}>Create Price Tags</a></li>
													<li><a href="" onClick={this.handleRedirection.bind(this, '/lookupserialno', 'Header Look Up Serial Numbers', '', true)}>Look Up Serial Numbers</a></li>
													{/* self.props.isEmployeeHasAccessTo('Update User') && <li><Link onClick={(e) => this.setHoverMenu(null)} to='/updateUser'>Manage User</Link></li> */}
												</React.Fragment>}
												{self.state.isNCRPAllowed && <li><a href="" onClick={this.handleNCRPOrder.bind(this)}>No Charge Replacement Parts</a></li>}
												{user.userDetails && user.userDetails.isSiteManagementAccess && <li><a href="" onClick={this.handleRedirection.bind(this, '/siteManagement', 'Header Site Management', '', true)}>Site Management</a></li>}
											</ul>
										</div>}
										</div>
									</div>
								</div>
								<div className="accordion-item accordionTopNavItem">
									<h2 className="accordion-header" id="flush-resources">
									<button className={`accordion-button ${this.state.showSideBar?'collapsed':''} accordionTopNavButton sideBarButton`} type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThreeResources" aria-expanded="false" aria-controls="flush-collapseThreeResources">
										Resources
									</button>
									</h2>
									<div id="flush-collapseThreeResources" className={`accordion-collapse collapse ${this.state.showSideBar?'':'show'}`} aria-labelledby="flush-resources" data-bs-parent="#accordionProduct">
									<div className="accordion-body accBodyNotCollapsed">
									{!isThisAccountRestricted && <div className="flyoutWrapper">
										<ul className="flyout mobileFlyout">
										{!isGEAPartsSalesAgreementSelected && <React.Fragment>handleAdvertisingPortal
												{isPricingAccess && <li><a href="" onClick={this.handlePriceSheets.bind(this)}>Price Sheets</a></li>}
												{isPricingAccess && !exceptionPartyId && <li><a href="" onClick={this.handlePriceBulletins.bind(this, 'requestType=bulletins', '/resources/bulletins', 'Header Price Bulletins', 'Price Bulletins')}>Price Bulletins</a></li>}
												<li><a href="" onClick={this.handleExportProduct.bind(this)}>Export Product & Pricing Information</a></li>
												{this.props.isAccessToMAPGuidelines && <li><a href="" onClick={this.handleGetHelpDocuments.bind(this, 'requestType=mapGuideLines', '/resources/mapguidelines', 'Header MAP Guidelines', 'MAP Guidelines')}>MAP Guidelines</a></li>}
												<li><a href="" onClick={this.handleGetHelpDocuments.bind(this, 'requestType=brandGuideLines', '/resources/brandguidelines', 'Header Brand Guidelines', 'Brand Guidelines')}>Brand Guidelines & Logos</a></li>
												<li><a onClick={this.handleCoopAdvertising.bind(this, 'https://gecoop.staging.acbtest.com/default.aspx', 'Header Coop Advertising', '_blank', false)} href="">Coop Advertising</a></li>
												{(typeOfAccount === 'RETAIL' || typeOfAccount === 'CONTRACT') && <li><a href="#"  onClick={this.handleAdvertisingPortal.bind(this)}>Advertising Portal</a></li>}
												{/*<li><a onClick={(e) => this.setHoverMenu(null)} href="http://www.geappliances.com/rebates_promotions/" target="_blank">Consumer Rebates & Special Offers</a></li>*/}
												<li><a onClick={this.handleRedirection.bind(this, '/resources/claimforms', 'Header Consumer Rebates & Claim Forms', '', true)} href="">Consumer Rebates & Claim Forms</a></li>
												{/*<li><a onClick={(e) => this.setHoverMenu(null)} href="https://www.geappliancerewards.com" target="_blank">SPIFFs and Monogram Rewards</a></li>*/}
												{isViewReportsAccess && <li><a onClick={this.handleRedirection.bind(this, '/product-purchase-report', 'Header Product Purchase Report', '', true)} href="">Product Purchase Report</a></li>}
												{isViewReportsAccess && isRetailSalesChannelCode && <li><a href="" onClick={this.handlePerformanceClick.bind(this)}>Performance Volume Rebate Tracker</a></li>}
												{isViewReportsAccess && isRetailAndContractSalesChannelCode && <li><a href="" onClick={this.handleMonogramClick.bind(this)}>Monogram Volume Rebate Tracker</a></li>}
												{isViewReportsAccess && (this.props.customerClassCodeOfSelectedAccount === 'APPLIANCE BUILDER DISTRIBUTOR' ||  this.props.customerClassCodeOfSelectedAccount === 'APARTMENT REPLACEMENT DIST') && <li><a href="" onClick={this.handlePrestigePIFTrackerClick.bind(this)}>Prestige PIF Tracker</a></li>}
												{isViewReportsAccess && (this.props.customerClassCodeOfSelectedAccount === 'APPLIANCE BUILDER DISTRIBUTOR' ||  this.props.customerClassCodeOfSelectedAccount === 'APARTMENT REPLACEMENT DIST') && <li><a href="" onClick={this.handleGeAppDistPifClick.bind(this)}>100% GE Appliances Distributor PIF</a></li>}
												<li><a onClick={this.handleRedirection.bind(this, 'https://service.dashboard.smarthqpro.com/signin', 'Header SmartHQ Service Admin Portal', '_blank', false)} href="">SmartHQ Service Admin Portal</a></li>
												<li><a onClick={this.handleRedirection.bind(this, '/request-product-price-content', 'Header Request Product & Price Content', '', true)} href="">Request Product & Price Content</a></li>
												<li><a onClick={this.handleRedirection.bind(this, '/resources/salesHandbooks', 'Header Customer Agreement Handbooks', '', true)} href="">Customer Agreement Handbooks</a></li>
												<li><a onClick={this.handleRedirection.bind(this, 'https://www.geappliances.com/pro/appliance-catalogs.htm', 'Header Product Catalogs', '_blank', false)} href="">Product Catalogs</a></li>
												<li><a onClick={this.handleRedirection.bind(this, 'http://www.2020.net/Login.aspx', 'Header GE 2020 CAD Catalog', '_blank', false)} href="">GE 2020 CAD Catalog</a></li>
												<li><a onClick={this.handleRedirection.bind(this, 'http://www.geappliances.com/design_center/', 'Header Kitchen Design Center', '_blank', false)} href="">Kitchen Design Center</a></li>
												{/* <li><a onClick={(e) => this.setHoverMenu(null)} href="https://customernet.geappliances.com/CustomerNet" target="_blank">Merchandising Store</a></li> */}
												<form id="ad_builder" name="ad_builder" method="post">
													<input type="hidden" id="ad_builder_data" name="DATA" />
												</form>
											</React.Fragment>}
											{isGEAPartsSalesAgreementSelected && <React.Fragment>
												<li><a href="" onClick={this.handleGetPartsCatalog}>Accessories Catalog</a></li>
												<li><a href="https://www.geapplianceparts.com/store/parts/filter-finder" target='_blank'>Filter Finder</a></li>
												<li><a href="https://www.apda.com/sections/find-distributor" target='_blank'>Find Authorized Distributors</a></li>
												{this.state.isFreightDocumentAvailable && <li><a href="" onClick={this.props.handleGetFreightDocument}>Freight Charges & Discounts</a></li>}
												<li><a href="https://geappliancespartsmarketing.mailchimpsites.com/" target='_blank'>Marketing Resources</a></li>
												{this.state.isMultiPackFileAvailable && <li><a href="" onClick={this.handleGetMultiPackFile}>Multi Pack File</a></li>}
												{isPricingAccess && <li><a href="" onClick={this.handleGetPartsPricingFile}>Pricing Files</a></li>}
												<li><a href="https://www.ordergeapplianceparts.com/" target='_blank'>Search for Parts</a></li>
												<li><a href="https://service.dashboard.smarthqpro.com/signin" target='_blank'>SmartHQ Service Admin Portal</a></li>
												<li><a href="" onClick={this.handleGetWeightAndDimensionsFile}>Weight and Dimensions</a></li>
											</React.Fragment>
											}
										</ul>
									</div>}
									</div>
									</div>
								</div>
								<div className="accordion-item accordionTopNavItem">
									<h2 className="accordion-header" id="flush-support">
										<button className={`accordion-button ${this.state.showSideBar?'collapsed':''} accordionTopNavButton sideBarButton`} type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFourSupport" aria-expanded="false" aria-controls="flush-collapseFourSupport">
											Support
										</button>
									</h2>
									<div id="flush-collapseFourSupport" className={`accordion-collapse collapse ${this.state.showSideBar?'':'show'}`} aria-labelledby="flush-support" data-bs-parent="#accordionProduct">
									<div className="accordion-body accBodyNotCollapsed">
									{isAllowPunchOutAccess ? 
										<div className="flyoutWrapper">
										<ul className="flyout mobileFlyout">
											<li><a onClick={this.handleRedirection.bind(this, '/helpdesk', 'Header CustomerNet Help Desk', '', true)} href="">CustomerNet Help Desk</a></li>
										</ul>
										</div> :
									!isThisAccountRestricted && <div className="flyoutWrapper">
										<ul className="flyout mobileFlyout">
											<li><a onClick={this.handleRedirection.bind(this, 'https://geappliancesacademy.com/', 'Header GEA Learning Portal', '_blank', false)} href="">GE Appliances Academy</a></li>
											<li><a onClick={this.handleRedirection.bind(this, 'https://airandwater.geappliancesco.com/', 'Header HVAC', '_blank', false)} href="">HVAC Learning Academy</a></li>
											<li><a onClick={this.handleRedirection.bind(this, '/training', 'Header CustomerNet Training', '', true)} href="">CustomerNet Training</a></li>
											<li><a onClick={this.handleRedirection.bind(this, '/helpdesk', 'Header CustomerNet Help Desk', '', true)} href="">CustomerNet Help Desk</a></li>
										</ul>
									</div>}
									</div>
									</div>
								</div>
							</div>
						</ul>
						<ul className='nav mobileUl' style={{flexWrap: 'nowrap'}}>
							<li className="nav-item mobileLiLogo flex-grow-1">
								<Link to="/home" className='nav-link d-inline-block'><img src="/images/ge-cnet--logo.png" alt="GE Appliances CustomerNet" title="GE Appliances CustomerNet" width={180}/>
								</Link>
							</li>
							<li className='nav-item mobileLiSearch'onClick={this.showSearchSection.bind(this)}>
								<Link to='' className='nav-link'>
								<svg xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 -960 960 960" width="30" fill="#434343">
										<path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z"/>
									</svg>
								</Link></li>
								<li className={!this.state.showSideBar?'nav-item mobileLiMenu':" nav-item d-none"} onClick={this.showSideBarMenuClick.bind(this)}>
								<Link to="" className='nav-link'>
								<svg xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 96 960 960" width="30">
										<path d="M120 816v-60h720v60H120Zm0-210v-60h720v60H120Zm0-210v-60h720v60H120Z"/>
									</svg>
								</Link>
							</li>
						</ul>
					</nav>
					{!self.state.showSearchMobileSection ? 
					<div className="accordion accordion-borderless d-block d-sm-none" id="accordionFlushExample">
						<div className="accordion-item mobileAccInfoItem">
							<h2 className="accordion-header" id="flush-headingOne">
							<button className="accordion-button collapsed mobileAccButton" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
								ACCOUNT INFORMATION
							</button>
							</h2>
							<div id="flush-collapseOne" className="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
							<div className="accordion-body">
									{/**** */}
									<div className="mastheadAccountNumberDropdownFormContainer mastheadFormContainer">
										<p>
											<b>Availability shown for:</b>
										</p>
										<div className="address-dropdown d-flex" style={{float: 'unset'}}>
										<select style={{width: "15rem", float: 'left'}} value={this.props.state.user.selectedAddress ? this.props.state.user.selectedAddress : ''} onChange={this.handleChangeAddress.bind(this)} disabled={this.props.isAnyAddressCallInProgress }>
											{!this.props.addressException ?shipToAddressList
												.slice()
												.sort((a, b) => {
												const addrA = (a && a.ADDRESS1) ? a.ADDRESS1.toLowerCase() : '';
												const addrB = (b && b.ADDRESS1) ? b.ADDRESS1.toLowerCase() : '';
												return addrA.localeCompare(addrB);
												})						
												.map((itm, ind) => {
													const list = [];
													if(itm.ADDRESS1) list.push(itm.ADDRESS1);
													if(itm.CITY) list.push(itm.CITY);
													if(itm.STATE) list.push(itm.STATE);
													if(itm.LOCATION) list.push(itm.LOCATION);
													return <option key={ind} value={JSON.stringify(itm)}>
														{list.join(', ')}
													</option>
												}):<option>{}</option>}
											</select>
											{!isGEAPartsSalesAgreementSelected && typeOfUser === 'employee' &&
											<select
											className={self.props.state.user.selectedADC !== self.props.state.user.defaultSelectedADC ? 'red px-4' : ''}
												onChange={self.handleChangeADC.bind(this)}
												value={self.props.state.user.selectedADC}
												style={{marginLeft: '1rem'}}
												disabled={
													self.props.state.user.selectedADC === 'CH2' ||
													self.props.state.user.selectedADC === 'FON' ||
													(userDetails.isNonGEASsoUser && userDetails.isManRepSsoUser && DISABLED_ADC_PATHS_FOR_MAN_REPS.includes(window.location.pathname))
													//isCanadianZipCode
												}
												>
													{adcList.map((item, index) => {
														if (
															(item.label === 'CH2' && self.props.state.user.selectedADC !== 'CH2') ||
															(item.label === 'FON' && self.props.state.user.selectedADC !== 'FON') ||
															(userDetails.isNonGEASsoUser && userDetails.isManRepSsoUser && DISABLED_ADC_PATHS_FOR_MAN_REPS.includes(window.location.pathname) && item.label !== self.props.state.user.selectedADC)
														) {
															return null;
														}
														return <option key={index}  value={item.label} className={item.label === this.props.state.user.defaultSelectedADC ? 'black' : 'red'}>{item.label}</option>
													})}
												</select>
											}
											<div style={{float: 'right'}} className={"loader account-number-loader " + (this.props.isAnyAddressCallInProgress ? "show" : "hide")}>&#160;</div>
										</div>
										<p style={{ fontSize: '.9em', marginBlock: '.5rem 0' }}>
											<a className="block" href="" onClick={this.handleSearchByStoreNumberOrLocation}>
												Search Address by Store Number or Location
											</a>
											{self.state.limitNewShipToAddressTo && <a className="block" href='' onClick={this.handleDialog.bind(this, 'NewShipToAddressOverlayDialog', true)} style={{ marginTop: '.5rem' }}>Add Address</a>}
										</p>
									</div>
									<div className="mastheadAccountNumberDropdownFormContainer mastheadFormContainer" style={{clear: 'both'}}>
										<p style={{fontSize: '0.9em', margin: 0, paddingTop:"15px"}}>
											<b>Account:</b><br />
											{selectedAccount && selectedAccount.ACCOUNTNUMBER}&nbsp;<b>-</b>&nbsp;{selectedAccount && selectedAccount.ACCOUNTDESCRIPTION}<br />
											<span><b>Sales Agreement:</b><br />
											{selectedPriceSource && selectedPriceSource.AGREEMENT_NAME}<br /></span>
											{!isAllowPunchOutAccess && <a href="" onClick={this.handleDialog.bind(this, 'SelectAccountAndPriceSourceOverlayDialog', true)}>Change</a>}
										</p>
										<p />
									</div>
									{/** */}
								</div>
							</div>
						</div>
						</div>:""}
						{self.state.showSearchMobileSection?<div className='searchMobile pb-2 d-block d-sm-none'>
						{isGEAPartsSalesAgreementSelected ? <PartsNetItemSearchBox ref={el => this.partsNetSearchBoxRef = el} getItemDetails={this.props.getItemDetails} isMobileView={true} isInternationalPartsCustomer={self.props.isInternationalPartsCustomer} /> : <form onSubmit={this.handleSearchSubmit.bind(this)} >
							<input type="text" name="searchFormSearchBoxMobile" 
							placeholder="Search" className="searchFormSearchMobile" 
							id="searchFormSearchBoxMobile"
								style={{width:"15rem"}}
								ref={(input) => { this.productNumberInput = input; }}
								onChange={this.handleChangeProductNumber.bind(this)}
								onKeyPress={this.validateSearchKeyword.bind(this)}
								onBlur={this.handleAutoSuggests.bind(this, true)}
								onFocus={this.handleAutoSuggests.bind(this, true)}
								autoComplete="off"
								value={this.props.state.searchKeyword.postLoginSearchKeyword}
							/>&nbsp;
							<input type="submit" style={{padding: "0.5rem 0.5rem", fontSize:"1rem", borderRadius:"5px"}} disabled={(this.productNumberInput && this.productNumberInput.value.trim().length < 3)?true:false} className="blueButton inspira uppercase" value="Search" />
							<div id="searchResults" className={this.state.showSuggestion && this.props.state.searchKeyword.postLoginSearchKeyword.trim() !== ""?"show searchResultsMobile":"hide"}>
								<div>
									<h3 className='searchResultsMobileHead'>Search Results</h3>
									<ul className='searchResultsUl'>
										{this.state.showSearchLoading
											?<li style={{listStyle:"none"}}><br/><div className="loader">&nbsp;</div><br/></li>
											:null
										}
										{!this.state.showSearchLoading && this.props.state.searchKeyword.productNumberList && this.props.state.searchKeyword.productNumberList.length === 0
											?<li style={{listStyle:"none", paddingLeft:"1rem"}}>No Results found.</li>
											:null
										}
										{!this.state.showSearchLoading && this.props.state.searchKeyword.productNumberList && this.props.state.searchKeyword.productNumberList.length > 0 && this.props.state.searchKeyword.productNumberList.map((item, index) => {
											var label = "",
												currentKeyword = this.productNumberInput.value.toUpperCase().trim().split(" ");
											currentKeyword = currentKeyword[currentKeyword.length-1];
											label = item.sku.replace(currentKeyword,"<strong>"+currentKeyword+"</strong>");
											return <li key={index}><a href="" className="no-style" onClick={this.handleSelectSuggestion.bind(this, item.sku)} dangerouslySetInnerHTML={{__html: label}}></a></li>
										})}
									</ul>
								</div>
								<div className="searchProducts clearfix">
									<h3 className='searchResultsMobileHead'>Product Results</h3>
									{this.state.showSearchLoading
										?<div className="clearfix"><br/><div className="loader">&nbsp;</div><br/></div>
										:null
									}
									{!this.state.showSearchLoading && this.props.state.searchKeyword.productNumberList && this.props.state.searchKeyword.productNumberList.length === 0
										?<div className="clearfix" style={{paddingLeft:"1rem"}}>No Results found.</div>
										:null
									}
									{!this.state.showSearchLoading && this.props.state.searchKeyword.productNumberList && this.props.state.searchKeyword.productNumberList.length > 0 && this.props.state.searchKeyword.productNumberList.map((item, index) => {
										return <div className="clearfix" key={index}>
										    <p className="prdtDesc" data-key={item.sku}><a href="" onClick={this.handleSkuClick.bind(this, item.sku)}>{item.sku}</a>{item.description}</p>
										    <div className="avail" data-key={item.sku}><b>Avail</b>{item.lifeCyclePhase === "Near End of Life"? 0 : item.availableQty}</div>
											{self.props.checkIfFP(item) || item.lifeCyclePhase === "Near End of Life"
												? <p className="addProductBtn"><a className="grayButton blockButton" style={{width: '100%'}} onClick={self.props.doNothing} href="" disabled>NLA</a></p>
												: <AddToCart
													checkAvailabilityGeneric={this.props.checkAvailabilityGeneric}
													fireGTMTag={this.props.fireGTMTag}
													brand={item.brand}
													category={item.category}
													getPimDataForCartItem={this.props.getPimDataForCartItem}
													item={item.sku}
													itemDescription={item.description}
													itemType={item.itemType}
													isTypeAhead={false}
													getZipCode={() => this.props.customZipCode}
													customADC={ this.props.customADC }
													getLegacyCustCode={this.props.getLegacyCustCode}
													getShippingAddressesDetails={this.props.getShippingAddressesDetails}
													makeParallelCallsForCartPrices={this.props.makeParallelCallsForCartPrices}
													getAddressesByCategory={this.props.getAddressesByCategory}
													getSalesAgreementParamForAvailability={this.props.getSalesAgreementParamForAvailability}
													searchSuggestions={`searchSuggestions`}
													checkAvailabilityForOrder={this.props.checkAvailabilityForOrder}
													formatOrderAvailabilityData={this.props.formatOrderAvailabilityData}
												/>}
											<AddToList searchSuggestions={`searchSuggestions`} checkAvailabilityGeneric={this.props.checkAvailabilityGeneric} fireGTMTag={this.props.fireGTMTag} getShippingAddressesDetails={this.props.getShippingAddressesDetails} item={item.sku} itemDescription={item.description} itemType={item.itemType} getZipCode={() => this.props.customZipCode} getLegacyCustCode={this.props.getLegacyCustCode} isTypeAhead={false} getSalesAgreementParamForAvailability={this.props.getSalesAgreementParamForAvailability} />
										</div>
									})}
								</div>
							</div>
							</form>}
					</div>:""}
	            <div className="masthead loggedIn">
					<div className="d-none d-sm-block customerNetLogo">
	                	<Link to="/home"><img className="customerNetLogo" src="/images/ge-cnet--logo.png" alt="GE Appliances CustomerNet" title="GE Appliances CustomerNet" /></Link>
	              	</div>
					  <div className="d-none d-sm-block upperRight">
	                	<div className="itemGroup">
							{!isGEAPartsSalesAgreementSelected && isViewOrdersAccess && (order.isBackOrdersAvailable || order.isBulkOrdersHoldAvailable)
								? <div className="item">
		                    		<a className="bold importantText" href="" onClick={this.checkForBackOrdersAndBulkOrderHold.bind(this)}>Backorders Available</a>
		                  		</div>
								: null
							}
							<div className="item">
								<a href="" onClick={this.handleGetHelpDocumentsURL.bind(this, 'requestType=help')}>Help</a>
							</div>
							{
								!isAllowPunchOutAccess &&
								<div className="item">
								<a className={user.userDetails && (user.userDetails.isNonGEASsoUser ? user.userDetails.isManRepSsoUser : (user.userDetails.isAdmin || user.userDetails.isASM || user.userDetails.isInDL)) && isPendingRequests?"importantText bold":""} href="" onClick={this.handleMyProfileClick}>My Profile</a>
								</div>
							}
							{
								!isAllowPunchOutAccess &&
							<div className="item">
								<a href="" onClick={this.props.logout}>Logout</a>
							</div>
							
							}
	                	</div>
						{
							!isGEAPartsSalesAgreementSelected && !isAllowPunchOutAccess &&
	                	<div className="itemGroup blueBackground">
	                  		<div className="item">
								<a href="" className="bold" onClick={this.handleListClick.bind(this)}>List {`(${listCount})`}</a>
	                  		</div>
	                	</div>
						}
						<div className="itemGroup redBackground">
							<div className="item">
								<a href="" className="bold" onClick={this.handleCartClick.bind(this)}>Cart {`(${cartCount})`}</a>
							</div>
						</div>
	              	</div>
					  <div className="d-none d-sm-block mastheadAccountNumberDropdownFormContainer mastheadFormContainer">
						<p className="availability-address-dropdown">
							<b className="block">Availability shown for:</b>
						</p>
						<div className="address-dropdown">
							<select style={{width: "87%", float: 'left'}} value={this.props.state.user.selectedAddress ? this.props.state.user.selectedAddress : ''} onChange={this.handleChangeAddress.bind(this)} disabled={this.props.isAnyAddressCallInProgress }>
							{!this.props.addressException ?shipToAddressList
								.slice() // create a shallow copy so the original is not mutated
								.sort((a, b) => {
									const addrA = (a && a.ADDRESS1) ? a.ADDRESS1.toLowerCase() : '';
									const addrB = (b && b.ADDRESS1) ? b.ADDRESS1.toLowerCase() : '';
									return addrA.localeCompare(addrB);
								})	
								.map((itm, ind) => {
									const list = [];
									if(itm.ADDRESS1) list.push(itm.ADDRESS1);
									if(itm.CITY) list.push(itm.CITY);
									if(itm.STATE) list.push(itm.STATE);
									if(itm.COUNTRY) list.push(itm.COUNTRY); // PNT-202
									if(itm.POSTALCODE) list.push(itm.POSTALCODE); // PNT-202
									if(itm.LOCATION) list.push(itm.LOCATION);
									return <option key={ind} value={JSON.stringify(itm)}>
										{list.join(', ')}
									</option>
								}): <option>{}</option>}
							</select>
							<div style={{float: 'right'}} className={"loader " + (this.props.isAnyAddressCallInProgress ? "show" : "hide")}>&#160;</div>
						</div>
						<p style={{ float: 'left', clear: 'both', fontSize: '.9em', marginBlock: '.5rem 0.25rem' }}>
							<a className="block" href="" onClick={this.handleSearchByStoreNumberOrLocation}>
								Search Address by Store Number or Location
							</a>
							{self.state.limitNewShipToAddressTo && <a className="block" href='' onClick={this.handleDialog.bind(this, 'NewShipToAddressOverlayDialog', true)} style={{ marginTop: '.5rem' }}>Add Address</a>}
						</p>
					</div>
					<div className="d-none d-sm-block mastheadAccountNumberDropdownFormContainer mastheadFormContainer" style={{clear: 'both'}}>
						<p style={{fontSize: '0.9em', margin: 0}}>
							{!isGEAPartsSalesAgreementSelected && window.location.pathname !== '/ncrp-order' && typeOfUser === 'employee' &&
								<select
									className={self.props.state.user.selectedADC !== self.props.state.user.defaultSelectedADC ? 'red' : ''}
									onChange={self.handleChangeADC.bind(this)}
									value={self.props.state.user.selectedADC}
									style={{float: 'right', width: '64px', marginRight: '5%'}}
									disabled={
										self.props.state.user.selectedADC === 'CH2' ||
										self.props.state.user.selectedADC === 'FON' ||
										(userDetails.isNonGEASsoUser && userDetails.isManRepSsoUser && DISABLED_ADC_PATHS_FOR_MAN_REPS.includes(window.location.pathname))
										//isCanadianZipCode
									}
								>
									{adcList.map((item, index) => {
										if (
											(item.label === 'CH2' && self.props.state.user.selectedADC !== 'CH2') ||
											(item.label === 'FON' && self.props.state.user.selectedADC !== 'FON') ||
											(userDetails.isNonGEASsoUser && userDetails.isManRepSsoUser && DISABLED_ADC_PATHS_FOR_MAN_REPS.includes(window.location.pathname) && item.label !== self.props.state.user.selectedADC)
										) {
											return null;
										}
										return <option key={index}  value={item.label} className={item.label === this.props.state.user.defaultSelectedADC ? 'black' : 'red'}>{item.label}</option>
									})}
								</select>
							}
							<b>Account:</b> {selectedAccount && selectedAccount.ACCOUNTNUMBER}&nbsp;<b>-</b>&nbsp;{selectedAccount && selectedAccount.ACCOUNTDESCRIPTION}<br />
							<span><b>Sales Agreement:</b> {selectedPriceSource && selectedPriceSource.AGREEMENT_NAME}<br /></span>
							{!isAllowPunchOutAccess && <a href="" onClick={this.handleDialog.bind(this, 'SelectAccountAndPriceSourceOverlayDialog', true)}>Change</a>}
						</p>
						<p />
					</div>
					{isGEAPartsSalesAgreementSelected && <div className="d-none d-sm-block mastheadSearchFormContainer mastheadFormContainer">
						<PartsNetItemSearchBox ref={el => this.partsNetSearchBoxRef = el} getItemDetails={this.props.getItemDetails} isInternationalPartsCustomer={self.props.isInternationalPartsCustomer} />
					</div>}
	              	<div className={`${isGEAPartsSalesAgreementSelected ? 'd-none' : 'd-none d-sm-block'} mastheadSearchFormContainer mastheadFormContainer`}>
	                	<form className="mastheadSearchForm" onSubmit={this.handleSearchSubmit.bind(this)} >
	                  		<label htmlFor="searchFormSearchBox">For multiple models, enter a space between model#.</label>
					  		<div className="product-number-error-msg">
								<p className="red">
									<strong>{/*this.state.productNumberError*/}</strong>
								</p>
							</div>
							<input type="text" 
							name="searchFormSearchBox" 
							className="searchFormSearchBox" 
							id="searchFormSearchBox"
								ref={(input) => { this.productNumberInput = input; }}
								onChange={this.handleChangeProductNumber.bind(this)}
								onKeyPress={this.validateSearchKeyword.bind(this)}
								onBlur={this.handleAutoSuggests.bind(this, false)}
								onFocus={this.handleAutoSuggests.bind(this, true)}
								autoComplete="off"
							/>&nbsp;
							<input type="submit" disabled={(this.productNumberInput && this.productNumberInput.value.trim().length < 3)?true:false} className="blueButton inspira uppercase" value="Search" />
							<div id="searchResults" className={this.state.showSuggestion && this.props.state.searchKeyword.postLoginSearchKeyword.trim() !== ""?"show":"hide"}>
								<div className="searchResults">
									<h3>Search Results</h3>
									<ul>
										{this.state.showSearchLoading
											?<li><br/><div className="loader">&nbsp;</div><br/></li>
											:null
										}
										{!this.state.showSearchLoading && this.props.state.searchKeyword.productNumberList && this.props.state.searchKeyword.productNumberList.length === 0
											?<li>No Results found.</li>
											:null
										}
										{!this.state.showSearchLoading && this.props.state.searchKeyword.productNumberList && this.props.state.searchKeyword.productNumberList.length > 0 && this.props.state.searchKeyword.productNumberList.map((item, index) => {
											var label = "",
												currentKeyword = this.productNumberInput.value.toUpperCase().trim().split(" ");
											currentKeyword = currentKeyword[currentKeyword.length-1];
											label = item.sku.replace(currentKeyword,"<strong>"+currentKeyword+"</strong>");
											return <li key={index}><a href="" className="no-style" onClick={this.handleSelectSuggestion.bind(this, item.sku)} dangerouslySetInnerHTML={{__html: label}}></a></li>
										})}
									</ul>
								</div>
								<div className="searchProducts clearfix">
									<h3>Product Results</h3>
									{this.state.showSearchLoading
										?<div className="clearfix"><br/><div className="loader">&nbsp;</div><br/></div>
										:null
									}
									{!this.state.showSearchLoading && this.props.state.searchKeyword.productNumberList && this.props.state.searchKeyword.productNumberList.length === 0
										?<div className="clearfix">No Results found.</div>
										:null
									}
									{!this.state.showSearchLoading && this.props.state.searchKeyword.productNumberList && this.props.state.searchKeyword.productNumberList.length > 0 && this.props.state.searchKeyword.productNumberList.map((item, index) => {
										return <div className="clearfix" key={index}>
										    <p className="prdtDesc" data-key={item.sku}><a href="" onClick={this.handleSkuClick.bind(this, item.sku)}>{item.sku}</a>{item.description}</p>
										    <div className="avail" data-key={item.sku}><b>Avail</b>{item.lifeCyclePhase === "Near End of Life"? 0 : item.availableQty}</div>
											{self.props.checkIfFP(item)
												? <p className="addProductBtn"><a className="grayButton blockButton" style={{width: '100%'}} onClick={self.props.doNothing} href="" disabled>NLA</a></p>
												: <AddToCart
													checkAvailabilityGeneric={this.props.checkAvailabilityGeneric}
													fireGTMTag={this.props.fireGTMTag}
													brand={item.brand}
													category={item.category}
													getPimDataForCartItem={this.props.getPimDataForCartItem}
													item={item.sku}
													itemDescription={item.description}
													itemType={item.itemType}
													isTypeAhead={false}
													getZipCode={() => this.props.customZipCode}
													customADC={ this.props.customADC }
													getLegacyCustCode={this.props.getLegacyCustCode}
													getShippingAddressesDetails={this.props.getShippingAddressesDetails}
													makeParallelCallsForCartPrices={this.props.makeParallelCallsForCartPrices}
													getAddressesByCategory={this.props.getAddressesByCategory}
													getSalesAgreementParamForAvailability={this.props.getSalesAgreementParamForAvailability}
													searchSuggestions={`searchSuggestions`}
													checkAvailabilityForOrder={this.props.checkAvailabilityForOrder}
													formatOrderAvailabilityData={this.props.formatOrderAvailabilityData}
													/>
											}
											<AddToList searchSuggestions={`searchSuggestions`} checkAvailabilityGeneric={this.props.checkAvailabilityGeneric} fireGTMTag={this.props.fireGTMTag} getShippingAddressesDetails={this.props.getShippingAddressesDetails} item={item.sku} itemDescription={item.description} itemType={item.itemType} getZipCode={() => this.props.customZipCode} getLegacyCustCode={this.props.getLegacyCustCode} isTypeAhead={false} getSalesAgreementParamForAvailability={this.props.getSalesAgreementParamForAvailability} />
										</div>
									})}
								</div>
							</div>
	                	</form>
	              	</div>
	              	<div className="clear">{/* DO NOT REMOVE */}</div>
					  <div className="d-none d-sm-block topNav">
					  <ul>
	                  {!isGEAPartsSalesAgreementSelected && <li onMouseOver={this.setHoverMenu.bind(this, 1)} onMouseOut={this.setHoverMenu.bind(this, null)} className={this.state.activeMenuIndex === 1?'hover':''}>
	                    <a href="" onClick={this.props.doNothing}>Products / Availability</a>
	                    <div className="flyoutWrapper">
	                     	<ul className="flyout">
								{/* packages will only for contract user, show in top */}
								{typeOfAccount === 'CONTRACT' &&
	                            	<li><a href="#" onClick={this.handlePackage.bind(this)}>Packages</a></li>
								}
								{selectedPriceSource && selectedPriceSource['Quote Type'] === 'Q' && <li>
									<a href="" onClick={this.handleQuoteModelSubmit.bind(this)}>Quote Models</a>
								</li>}
								{product.productLineList.map((item, index) =>{
									  if (item.name === 'HVAC') {
											return <li key={index} onMouseEnter={this.handleMainCategoryHover.bind(this)}
														onMouseLeave={this.handleMainCategoryLeave.bind(this)} >
														
														<a href="#">{item.name}</a>
															{this.state.showSubcategories && item.subCategory && (
																<ul>
																	{item.subCategory.map((subItem, subIndex) => (
																		<li key={subIndex} style={{ marginBottom: '20px' }}>
																		<a  style={{color:'black',textDecoration:'none' }}
																			href="#"
																			onClick={this.redirectProductLineSearch.bind(this, "?N=" + subItem.categoryId, subItem.name)}>
																			{subItem.name}
																		</a>
																		</li>
																	))}
																</ul>
															)}
													</li>
									 	}
										else{
											return <li key={index}>
														<a href="" onClick={this.redirectProductLineSearch.bind(this, "?N=" + item.categoryId, item.name)}>{item.name}
														</a>
													</li>
										}
								})}
								{(typeOfAccount === 'RETAIL' || this.props.customerClassCodeOfSelectedAccount === 'APPLIANCE BUILDER DISTRIBUTOR' ||  this.props.customerClassCodeOfSelectedAccount === 'APARTMENT REPLACEMENT DIST' ||
								this.props.customerClassCodeOfSelectedAccount === 'AWS PRO - DISTRIBUTORS' || this.props.customerClassCodeOfSelectedAccount === 'HOSPITALITY DISTRIBUTOR') &&
									<li><a href="" onClick={this.redirectProductLineSearch.bind(this, "?N=4294944698", "Closeouts")}>Closeouts</a></li>
								}
								{(typeOfAccount === 'RETAIL' || typeOfAccount === 'PRO CHANNEL' || typeOfAccount === 'HQ') &&
	                            	<li><a href="#" onClick={this.handlePackage.bind(this)}>Packages</a></li>
								}
	                      	</ul>
	                    </div>
	                  </li>}
	                  <li onMouseOver={this.setHoverMenu.bind(this, 2)} onMouseOut={this.setHoverMenu.bind(this, null)} className={this.state.activeMenuIndex === 2?'hover':''}>
	                    <a href="" onClick={this.props.doNothing}>Tools</a>
	                    {isAllowPunchOutAccess ? 
							<div className="flyoutWrapper">
								<ul className="flyout">
									<li><a href="" onClick={this.handleManageOrder.bind(this)}>Manage Orders</a></li>
								</ul> 
							</div> :
						!isThisAccountRestricted && <div className="flyoutWrapper">
	                        <ul className="flyout">
								{isViewOrdersAccess && <li><a href="" onClick={this.handleManageOrder.bind(this)}>Manage Orders</a></li>}
								<li><a href="" onClick={this.handleQuickOrder.bind(this)}>Quick Order{isGEAPartsSalesAgreementSelected && ' / Availability'}</a></li>
							    {!isGEAPartsSalesAgreementSelected && <React.Fragment>
									{self.props.hasRequestReturnAccess && <li><a href="" onClick={this.handleRequestReturn.bind(this)}>Request Return</a></li>}
									{self.props.hasRequestCreditAccess && <li><a href="" onClick={this.handleRequestCredit.bind(this)}>Request Credit</a></li>}
									{isViewReturnsCreditAccess && <li>
										<a href="" onClick={this.handleViewReturnsAndCredits.bind(this)}>View Returns & Credits</a>
									</li>}
									{self.props.isEmployeeHasAccessTo('Approve Returns') &&
										<li>
											<a href="" onClick={this.handleApproveReturns.bind(this)}>Approve Returns and Credits</a>
										</li>
									}
								</React.Fragment>}
								{isInvoicesAndPaymentAccess && <li><a href="" onClick={this.handleViewInvoices.bind(this)}>View & Print Invoices</a></li>}
								{isInvoicesAndPaymentAccess && <li><a onClick={this.handleRedirection.bind(this, typeOfUser === 'customer'?searchAndPayInvoicesURLCust:searchAndPayInvoicesURLEmp, 'Header Search & Pay Invoices', '_blank', false)} href="">Search & Pay Invoices</a></li>}
								{!isGEAPartsSalesAgreementSelected && <React.Fragment>
									<li><a href="" onClick={this.handleRedirection.bind(this, '/carrierinformation', 'Header Carrier Information', '', true)}>Carrier Information</a></li>
									{isPricingAccess && <li><a href="" onClick={this.handleCreatePackage.bind(this)}>Create Package</a></li>}
									<li><a href="" onClick={this.handleCreateBrochureDialog.bind(this, 1)}>Create Brochure</a></li>
									<li><a href="" onClick={this.handleSavedBrochures.bind(this)}>Saved Brochures</a></li>
									<li><a href="" onClick={this.handleCreatePriceTags.bind(this)}>Create Price Tags</a></li>
									<li><a href="" onClick={this.handleRedirection.bind(this, '/lookupserialno', 'Header Look Up Serial Numbers', '', true)}>Look Up Serial Numbers</a></li>
	                            	{/* self.props.isEmployeeHasAccessTo('Update User') && <li><Link onClick={(e) => this.setHoverMenu(null)} to='/updateUser'>Manage User</Link></li> */}
								</React.Fragment>}
								{self.state.isNCRPAllowed && <li><a href="" onClick={this.handleNCRPOrder.bind(this)}>No Charge Replacement Parts</a></li>}
								{user.userDetails && user.userDetails.isSiteManagementAccess && <li><a href="" onClick={this.handleRedirection.bind(this, '/siteManagement', 'Header Site Management', '', true)}>Site Management</a></li>}
	                        </ul>
	                    </div>}
	                  </li>
					  {!isAllowPunchOutAccess &&
	                  <li onMouseOver={this.setHoverMenu.bind(this, 3)} onMouseOut={this.setHoverMenu.bind(this, null)} className={this.state.activeMenuIndex === 3?'hover':''}>
	                    <a href="" onClick={this.props.doNothing}>Resources</a>
	                    {!isThisAccountRestricted && <div className="flyoutWrapper">
	                        <ul className="flyout">
								{!isGEAPartsSalesAgreementSelected && <React.Fragment>
									{isPricingAccess && <li><a href="" onClick={this.handlePriceSheets.bind(this)}>Price Sheets</a></li>}
									{isPricingAccess && !exceptionPartyId && <li><a href="" onClick={this.handlePriceBulletins.bind(this, 'requestType=bulletins', '/resources/bulletins', 'Header Price Bulletins', 'Price Bulletins')}>Price Bulletins</a></li>}
									<li><a href="" onClick={this.handleExportProduct.bind(this)}>Export Product & Pricing Information</a></li>
									{this.props.isAccessToMAPGuidelines && <li><a href="" onClick={this.handleGetHelpDocuments.bind(this, 'requestType=mapGuideLines', '/resources/mapguidelines', 'Header MAP Guidelines', 'MAP Guidelines')}>MAP Guidelines</a></li>}
								<li><a href="" onClick={this.handleGetHelpDocuments.bind(this, 'requestType=brandGuideLines', '/resources/brandguidelines', 'Header Brand Guidelines', 'Brand Guidelines')}>Brand Guidelines & Logos</a></li>
								<li><a onClick={this.handleCoopAdvertising.bind(this, 'https://gecoop.staging.acbtest.com/default.aspx', 'Header Coop Advertising', '_blank', false)} href="#">Coop Advertising</a></li>
								{(typeOfAccount === 'RETAIL' || typeOfAccount === 'CONTRACT') && <li><a href="#"  onClick={this.handleAdvertisingPortal.bind(this)}>Advertising Portal</a></li>}
									{/*<li><a onClick={(e) => this.setHoverMenu(null)} href="http://www.geappliances.com/rebates_promotions/" target="_blank">Consumer Rebates & Special Offers</a></li>*/}
									<li><a onClick={this.handleRedirection.bind(this, '/resources/claimforms', 'Header Consumer Rebates & Claim Forms', '', true)} href="">Consumer Rebates & Claim Forms</a></li>
									{/*<li><a onClick={(e) => this.setHoverMenu(null)} href="https://www.geappliancerewards.com" target="_blank">SPIFFs and Monogram Rewards</a></li>*/}
									{isViewReportsAccess && <li><a onClick={this.handleRedirection.bind(this, '/product-purchase-report', 'Header Product Purchase Report', '', true)} href="">Product Purchase Report</a></li>}
									{isViewReportsAccess && isRetailSalesChannelCode && <li><a href="" onClick={this.handlePerformanceClick.bind(this)}>Performance Volume Rebate Tracker</a></li>}
									{isViewReportsAccess && isRetailAndContractSalesChannelCode && <li><a href="" onClick={this.handleMonogramClick.bind(this)}>Monogram Volume Rebate Tracker</a></li>}
									{isViewReportsAccess && (this.props.customerClassCodeOfSelectedAccount === 'APPLIANCE BUILDER DISTRIBUTOR' 
										||  this.props.customerClassCodeOfSelectedAccount === 'APARTMENT REPLACEMENT DIST') && <li>
											<a href="" onClick={this.handlePrestigePIFTrackerClick.bind(this)}>Prestige PIF Tracker</a></li>}
									{isViewReportsAccess && (this.props.customerClassCodeOfSelectedAccount === 'APPLIANCE BUILDER DISTRIBUTOR' 
										||  this.props.customerClassCodeOfSelectedAccount === 'APARTMENT REPLACEMENT DIST') && <li>
											<a href="" onClick={this.handleGeAppDistPifClick.bind(this)}>100% GE Appliances Distributor PIF</a></li>}
									<li><a onClick={this.handleRedirection.bind(this, 'https://service.dashboard.smarthqpro.com/signin', 'Header SmartHQ Service Admin Portal', '_blank', false)} href="">SmartHQ Service Admin Portal</a></li>
									<li><a onClick={this.handleRedirection.bind(this, '/request-product-price-content', 'Header Request Product & Price Content', '', true)} href="">Request Product & Price Content</a></li>
									<li><a onClick={this.handleRedirection.bind(this, '/resources/salesHandbooks', 'Header Customer Agreement Handbooks', '', true)} href="">Customer Agreement Handbooks</a></li>
									<li><a onClick={this.handleRedirection.bind(this, 'https://www.geappliances.com/pro/appliance-catalogs.htm', 'Header Product Catalogs', '_blank', false)} href="">Product Catalogs</a></li>
									<li><a onClick={this.handleRedirection.bind(this, 'http://www.2020.net/Login.aspx', 'Header GE 2020 CAD Catalog', '_blank', false)} href="">GE 2020 CAD Catalog</a></li>
									<li><a onClick={this.handleRedirection.bind(this, 'http://www.geappliances.com/design_center/', 'Header Kitchen Design Center', '_blank', false)} href="">Kitchen Design Center</a></li>
									{/* <li><a onClick={(e) => this.setHoverMenu(null)} href="https://customernet.geappliances.com/CustomerNet" target="_blank">Merchandising Store</a></li> */}
									<form id="ad_builder" name="ad_builder" method="post">
										<input type="hidden" id="ad_builder_data" name="DATA" />
									</form>
								</React.Fragment>}
								{isGEAPartsSalesAgreementSelected && <React.Fragment>
									<li><a href="" onClick={this.handleGetPartsCatalog}>Accessories Catalog</a></li>
									<li><a href="https://www.geapplianceparts.com/store/parts/filter-finder" target='_blank'>Filter Finder</a></li>
									<li><a href="https://www.apda.com/sections/find-distributor" target='_blank'>Find Authorized Distributors</a></li>
									{this.state.isFreightDocumentAvailable && <li><a href="" onClick={this.props.handleGetFreightDocument}>Freight Charges & Discounts</a></li>}
									<li><a href="https://geappliancespartsmarketing.mailchimpsites.com/" target='_blank'>Marketing Resources</a></li>
									{this.state.isMultiPackFileAvailable && <li><a href="" onClick={this.handleGetMultiPackFile}>Multi Pack File</a></li>}
									{isPricingAccess && <li><a href="" onClick={this.handleGetPartsPricingFile}>Pricing Files</a></li>}
									<li><a href="https://www.ordergeapplianceparts.com/" target='_blank'>Search for Parts</a></li>
									<li><a href="https://service.dashboard.smarthqpro.com/signin" target='_blank'>SmartHQ Service Admin Portal</a></li>
									<li><a href="" onClick={this.handleGetWeightAndDimensionsFile}>Weight and Dimensions</a></li>
								</React.Fragment>}
	                        </ul>
	                    </div>}
	                  </li>}
	                  <li onMouseOver={this.setHoverMenu.bind(this, 4)} onMouseOut={this.setHoverMenu.bind(this, null)} className={this.state.activeMenuIndex === 4?'hover':''}>
	                    <a href="" onClick={this.props.doNothing}>Support</a>
	                    {isAllowPunchOutAccess ? 
							<div className="flyoutWrapper">
							<ul className="flyout">
								<li><a onClick={this.handleRedirection.bind(this, '/helpdesk', 'Header CustomerNet Help Desk', '', true)} href="">CustomerNet Help Desk</a></li>
							</ul>
							</div> :
						
						!isThisAccountRestricted && <div className="flyoutWrapper">
	                        <ul className="flyout">
								<li><a onClick={this.handleRedirection.bind(this, 'https://geappliancesacademy.com/', 'Header GEA Learning Portal', '_blank', false)} href="">GE Appliances Academy</a></li>
								<li><a onClick={this.handleRedirection.bind(this, 'https://airandwater.geappliancesco.com/', 'Header HVAC Learning Academy', '_blank', false)} href="">HVAC Learning Academy</a></li>
								<li><a onClick={this.handleRedirection.bind(this, '/training', 'Header CustomerNet Training', '', true)} href="">CustomerNet Training</a></li>
								<li><a onClick={this.handleRedirection.bind(this, '/helpdesk', 'Header CustomerNet Help Desk', '', true)} href="">CustomerNet Help Desk</a></li>
	                        </ul>
	                    </div>}
	                  </li>
	                </ul>
	              </div>
				  	{this.state.showGenericOverlayDialog?<GenericOverlayDialog flag='GenericOverlayDialog' genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons={this.state.modalButtons} handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
					{this.state.showPackageNotFoundOverlayDialog?<GenericOverlayDialog flag={'PackageNotFoundOverlayDialog'} genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons={this.state.modalButtons} handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
					{this.state.showSavedBrochuresNotFoundOverlayDialog?<GenericOverlayDialog flag={'SavedBrochuresNotFoundOverlayDialog'} genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons={this.state.modalButtons} handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
					{this.state.showCreatePriceTagDialog?<CreatePriceTagRedirectDialog fireGTMTag={this.props.fireGTMTag} showDialog={true} />:null}
					{this.state.showNoHelpResultsFoundOverlayDialog?<NoHelpResultsFoundOverlayDialog showDialog={true} />:null}
					{this.props.state.user.isSessionExpired?<SessionStatusOverlayDialog logout={this.props.logout} showDialog={true} />:null}
					{this.state.showSelectAccountAndPriceSourceOverlayDialog
						?<SelectAccountAndPriceSourceOverlayDialog
							fetchHomePageAssets={this.props.fetchHomePageAssets}
							acceptNumbersOnly={this.props.acceptNumbersOnly}
							getAccountDetailsAndAddressList={this.props.getAccountDetailsAndAddressList}
							getAccountDetails={this.props.getAccountDetails}
							saveSelectedAccountAndPriceSourceToLocalStorage={this.props.saveSelectedAccountAndPriceSourceToLocalStorage}
							handleDialog={this.handleDialog.bind(this)}
							showDialog={true}
							setDefaultADC={this.props.setDefaultADC}
							getLocalStorageVar={this.props.getLocalStorageVar}
							getPriceSources={this.props.getPriceSources}
							clearDeliveryMethodFromBackup={this.props.clearDeliveryMethodFromBackup}
							punchOutAccNumber={user.userDetails.punchOutAccNumber}
							punchOutSalesNumber={user.userDetails.punchOutSalesNumber}
							isPunchOut={isAllowPunchOutAccess}
							clearPartsSearchData={this.clearPartsSearchData}
						/>
						:null
					}
					{self.state.limitNewShipToAddressTo && this.state.showNewShipToAddressOverlayDialog ? <NewShipToAddressOverlayDialog showDialog={true} onClose={this.handleDialog.bind(this, 'NewShipToAddressOverlayDialog', false)} limitNewShipToAddressTo={self.state.limitNewShipToAddressTo} soldToAddress={self.state.soldToAddress} saveCustomZipCode={self.props.saveCustomZipCode} /> : null}
					{this.state.showAddressSearchDialog && <AddressSearchDialog getCombinedAddresses={this.props.getCombinedAddresses} onConfirm={this.handleAddressSelection} onClose={this.handleDialog.bind(this, 'AddressSearchDialog', false)} />}
				</div>
				<div style={{display:"none"}}>
					<form id="acb" name="acb" method="post" action='https://gecoop.acbcoop.com/default.aspx'>
						<input type="hidden" id="DATA" name="DATA" value=""/>
					</form>
				</div>
			</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getPackageList: (queryStringParams, callback) => dispatch(getPackageList(queryStringParams, callback)),
	savePackageList: (packageList) => dispatch(savePackageList(packageList)),
	getSavedBrochures: (queryStringParams, callback) => dispatch(getSavedBrochures(queryStringParams, callback)),
	getSavedExports: (payload, callback) => dispatch(getSavedExports(payload, callback)),
	getUserProfile: (payload, callback) => dispatch(getUserProfile(payload, callback)),
	getPerformanceData: (queryStringParams, callback) => dispatch(getPerformanceData(queryStringParams, callback)),
	getMonogramData: (queryStringParams, callback) => dispatch(getMonogramData(queryStringParams, callback)),
	getGeDistributorData: (queryStringParams, callback) => dispatch(getGeDistributorData(queryStringParams, callback)),
	getPrestigeData: (queryStringParams, callback) => dispatch(getPrestigeData(queryStringParams, callback)),
	getDocuments: (queryStringParams, willSaveToStore, callback) => dispatch(getDocuments(queryStringParams, willSaveToStore, callback)),
	saveUserProfile: (data) => dispatch(saveUserProfile(data)),
	getLocalUserDetails: (data, callback) => dispatch(getLocalUserDetails(data, callback)),
	getSalesAgreementHandBook: (queryString, callback) => dispatch(getSalesAgreementHandBook(queryString, callback)),
	savePostLoginSearchKeyword: (data) => dispatch(savePostLoginSearchKeyword(data)),
	resetSearchKeywordSuggestionList: () => dispatch(resetSearchKeywordSuggestionList()),
	saveSearchKeywordSuggestionList: (data) => dispatch(saveSearchKeywordSuggestionList(data)),
	getSearchKeywordSuggestionList: (payload, callback) => dispatch(getSearchKeywordSuggestionList(payload, callback)),
	updateFromWhereProductLineClicked: (data) => dispatch(updateFromWhereProductLineClicked(data)),
	saveProductLine: (data) => dispatch(saveProductLine(data)),
	updateAvailabilityWithPricesAndDiscounts: () => dispatch(updateAvailabilityWithPricesAndDiscounts()),
	saveProductLineNarrowYourResultsFilters: (data) => dispatch(saveProductLineNarrowYourResultsFilters(data)),
	getProductLineNarrorYourResultFilters: (payload) => dispatch(getProductLineNarrorYourResultFilters(payload)),
	checkPricesForSearchResult: (data, showLoader, saveToStore, callback) => dispatch(checkPricesForSearchResult(data, showLoader, saveToStore, callback)),
	getProductLineFilters: (payload, hybridQueryParams, callback) => dispatch(getProductLineFilters(payload, hybridQueryParams, callback)),
	saveBackOrders: (data) => dispatch(saveBackOrders(data)),
	saveBulkOrdersHold: (data) => dispatch(saveBulkOrdersHold(data)),
	saveManageOrdersListBackup: (data) => dispatch(saveManageOrdersListBackup(data)),
	// getUsersOfAccount: (queryStringParams, showLoader) => dispatch(getUsersOfAccount(queryStringParams, showLoader)),
	checkServicesPricesForCartPage: (payload, params, response) => dispatch(checkServicesPricesForCartPage(payload, params, response)),
	updateCartOrderPoints: (data) => dispatch(updateCartOrderPoints(data)),
	saveClaimFormsDocuments: (data) => dispatch(saveClaimFormsDocuments(data)),
	saveFullCatalogDocuments: (data) => dispatch(saveFullCatalogDocuments(data)),
	getGEAdBuilderKey: (queryStringParams, callback) => dispatch(getGEAdBuilderKey(queryStringParams, callback)),
	getEncryptedACB: (queryStringParams, callback) => dispatch(getEncryptedACB(queryStringParams, callback)),
	resetProductNumberKeywordResultList: () => dispatch(resetProductNumberKeywordResultList()),
	resetProductAvailabilityResultList: () => dispatch(resetProductAvailabilityResultList()),
	resetProductPricesResultList: () => dispatch(resetProductPricesResultList()),
	saveMonogramData: (data) => dispatch(saveMonogramData(data)),
	savePerformanceData: (data) => dispatch(savePerformanceData(data)),
	savePrestigeData: (data) => dispatch(savePrestigeData(data)),
	saveGeDistributorData: (data) => dispatch(saveGeDistributorData(data)),
	updateSelectedAddress: (data) => dispatch(updateSelectedAddress(data)),
	setSelectedADC: (data) => dispatch(setSelectedADC(data)),
	selectBrochureCreateOption: (data) => dispatch(selectBrochureCreateOption(data)),
	/*new brochure single change*/
	selectFeatureCreateOption: (data) => dispatch(selectFeatureCreateOption(data)),
	resetBrochurePayload: (accountNumber) => dispatch(resetBrochurePayload(accountNumber)),
	savePimDataForList: (data) => dispatch(savePimDataForList(data)),
	saveViewRequestsListBackup: (data) => dispatch(saveViewRequestsListBackup(data)),
	clearDeliveryMethodFromBackup: () => dispatch(clearDeliveryMethodFromBackup()),
	saveMobileView:(data) => dispatch(saveMobileView(data)),
	getFileURL: (path, queryString, callback) => dispatch(getFileURL(path, queryString, callback)),
	saveSelectedAddressBackup: data => dispatch(saveSelectedAddressBackup(data))
});

Header = connect(mapStateToProps, mapDispatchToProps)(Header);
export default Header;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/common/Header/index.js